var vo = Object.defineProperty, go = Object.defineProperties;
var mo = Object.getOwnPropertyDescriptors;
var ze = Object.getOwnPropertySymbols;
var Wr = Object.prototype.hasOwnProperty, Kr = Object.prototype.propertyIsEnumerable;
var wt = (e, t, r) => t in e ? vo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, D = (e, t) => {
  for (var r in t || (t = {}))
    Wr.call(t, r) && wt(e, r, t[r]);
  if (ze)
    for (var r of ze(t))
      Kr.call(t, r) && wt(e, r, t[r]);
  return e;
}, B = (e, t) => go(e, mo(t));
var It = (e, t) => {
  var r = {};
  for (var n in e)
    Wr.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && ze)
    for (var n of ze(e))
      t.indexOf(n) < 0 && Kr.call(e, n) && (r[n] = e[n]);
  return r;
};
var S = (e, t, r) => wt(e, typeof t != "symbol" ? t + "" : t, r);
var F = (e, t, r) => new Promise((n, i) => {
  var o = (u) => {
    try {
      s(r.next(u));
    } catch (c) {
      i(c);
    }
  }, a = (u) => {
    try {
      s(r.throw(u));
    } catch (c) {
      i(c);
    }
  }, s = (u) => u.done ? n(u.value) : Promise.resolve(u.value).then(o, a);
  s((r = r.apply(e, t)).next());
});
const yo = ({ apiKey: e }) => {
  (function(t, r) {
    var n = t.amplitude || { _q: [], _iq: {} }, i = r.createElement("script");
    i.type = "text/javascript", i.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", i.crossOrigin = "anonymous", i.async = !0, i.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", i.onload = function() {
      t.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(e);
    };
    var o = r.getElementsByTagName("script")[0];
    o.parentNode.insertBefore(i, o);
    function a(p, v) {
      p.prototype[v] = function() {
        return this._q.push([v].concat(Array.prototype.slice.call(arguments, 0))), this;
      };
    }
    for (var s = function() {
      return this._q = [], this;
    }, u = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], c = 0; c < u.length; c++)
      a(s, u[c]);
    n.Identify = s;
    for (var l = function() {
      return this._q = [], this;
    }, f = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], d = 0; d < f.length; d++)
      a(l, f[d]);
    n.Revenue = l;
    var _ = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function E(p) {
      function v(O) {
        p[O] = function() {
          p._q.push([O].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var T = 0; T < _.length; T++)
        v(_[T]);
    }
    E(n), n.getInstance = function(p) {
      return p = (!p || p.length === 0 ? "$default_instance" : p).toLowerCase(), Object.prototype.hasOwnProperty.call(n._iq, p) || (n._iq[p] = { _q: [] }, E(n._iq[p])), n._iq[p];
    }, t.amplitude = n;
  })(window, document);
}, Oo = ({ projectToken: e }) => {
  if (window.mixpanel)
    return;
  (function(r, n) {
    if (!n.__SV) {
      var i, o;
      window.mixpanel = n, n._i = [], n.init = function(a, s, u) {
        function c(d, _) {
          var E = _.split(".");
          E.length == 2 && (d = d[E[0]], _ = E[1]), d[_] = function() {
            d.push([_].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        var l = n;
        for (typeof u != "undefined" ? l = n[u] = [] : u = "mixpanel", l.people = l.people || [], l.toString = function(d) {
          var _ = "mixpanel";
          return u !== "mixpanel" && (_ += "." + u), d || (_ += " (stub)"), _;
        }, l.people.toString = function() {
          return l.toString(1) + ".people (stub)";
        }, i = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), o = 0; o < i.length; o++)
          c(l, i[o]);
        var f = "set set_once union unset remove delete".split(" ");
        l.get_group = function() {
          function d(v) {
            _[v] = function() {
              call2_args = arguments, call2 = [v].concat(Array.prototype.slice.call(call2_args, 0)), l.push([E, call2]);
            };
          }
          for (var _ = {}, E = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), p = 0; p < f.length; p++)
            d(f[p]);
          return _;
        }, n._i.push([a, s, u]);
      }, n.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const t = document.createElement("script");
  t.src = So, document.head.appendChild(t), t.addEventListener("load", () => {
    var r;
    (r = window.mixpanel) == null || r.init(e);
  });
}, So = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js", yp = 1e3, Op = 2e3, Sp = 144e5;
const Rp = {
  normal: {
    bytes: 1e7,
    time: 24e4
  },
  canvas: {
    bytes: 16e6,
    time: 5e3
  }
}, Ap = 100, Ro = "app.highlight.io";
var Wn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Kn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jn = { exports: {} }, Pt = { exports: {} }, Jr;
function Ao() {
  return Jr || (Jr = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Wn, function() {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }
      function n(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }
      function i(p) {
        return function() {
          return this[p];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], s = ["fileName", "functionName", "source"], u = ["args"], c = ["evalOrigin"], l = o.concat(a, s, u, c);
      function f(p) {
        if (p)
          for (var v = 0; v < l.length; v++)
            p[l[v]] !== void 0 && this["set" + n(l[v])](p[l[v]]);
      }
      f.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(p) {
          if (Object.prototype.toString.call(p) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(p) {
          if (p instanceof f)
            this.evalOrigin = p;
          else if (p instanceof Object)
            this.evalOrigin = new f(p);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var p = this.getFileName() || "", v = this.getLineNumber() || "", T = this.getColumnNumber() || "", O = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + v + ":" + T + ")" : "[eval]:" + v + ":" + T : O ? O + " (" + p + ":" + v + ":" + T + ")" : p + ":" + v + ":" + T;
        }
      }, f.fromString = function(v) {
        var T = v.indexOf("("), O = v.lastIndexOf(")"), b = v.substring(0, T), I = v.substring(T + 1, O).split(","), H = v.substring(O + 1);
        if (H.indexOf("@") === 0)
          var U = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(H, ""), bt = U[1], qe = U[2], Re = U[3];
        return new f({
          functionName: b,
          args: I || void 0,
          fileName: bt,
          lineNumber: qe || void 0,
          columnNumber: Re || void 0
        });
      };
      for (var d = 0; d < o.length; d++)
        f.prototype["get" + n(o[d])] = i(o[d]), f.prototype["set" + n(o[d])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = !!v;
          };
        }(o[d]);
      for (var _ = 0; _ < a.length; _++)
        f.prototype["get" + n(a[_])] = i(a[_]), f.prototype["set" + n(a[_])] = /* @__PURE__ */ function(p) {
          return function(v) {
            if (!r(v))
              throw new TypeError(p + " must be a Number");
            this[p] = Number(v);
          };
        }(a[_]);
      for (var E = 0; E < s.length; E++)
        f.prototype["get" + n(s[E])] = i(s[E]), f.prototype["set" + n(s[E])] = /* @__PURE__ */ function(p) {
          return function(v) {
            this[p] = String(v);
          };
        }(s[E]);
      return f;
    });
  }(Pt)), Pt.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(Ao());
  })(Wn, function(n) {
    var i = /(^|@)\S+:\d+/, o = /^\s*at .*(\S+:\d+|\(native\))/m, a = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(u) {
        if (typeof u.stacktrace != "undefined" || typeof u["opera#sourceloc"] != "undefined")
          return this.parseOpera(u);
        if (u.stack && u.stack.match(o))
          return this.parseV8OrIE(u);
        if (u.stack)
          return this.parseFFOrSafari(u);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(u) {
        if (u.indexOf(":") === -1)
          return [u];
        var c = /(.+?)(?::(\d+))?(?::(\d+))?$/, l = c.exec(u.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function(u) {
        var c = u.stack.split(`
`).filter(function(l) {
          return !!l.match(o);
        }, this);
        return c.map(function(l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var f = l.replace(/^\s+/, "").replace(/\(eval code/g, "("), d = f.match(/ (\((.+):(\d+):(\d+)\)$)/);
          f = d ? f.replace(d[0], "") : f;
          var _ = f.split(/\s+/).slice(1), E = this.extractLocation(d ? d[1] : _.pop()), p = _.join(" ") || void 0, v = ["eval", "<anonymous>"].indexOf(E[0]) > -1 ? void 0 : E[0];
          return new n({
            functionName: p,
            fileName: v,
            lineNumber: E[1],
            columnNumber: E[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function(u) {
        var c = u.stack.split(`
`).filter(function(l) {
          return !l.match(a);
        }, this);
        return c.map(function(l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1)
            return new n({
              functionName: l
            });
          var f = /((.*".+"[^@]*)?[^@]*)(?:@)/, d = l.match(f), _ = d && d[1] ? d[1] : void 0, E = this.extractLocation(l.replace(f, ""));
          return new n({
            functionName: _,
            fileName: E[0],
            lineNumber: E[1],
            columnNumber: E[2],
            source: l
          });
        }, this);
      },
      parseOpera: function(u) {
        return !u.stacktrace || u.message.indexOf(`
`) > -1 && u.message.split(`
`).length > u.stacktrace.split(`
`).length ? this.parseOpera9(u) : u.stack ? this.parseOpera11(u) : this.parseOpera10(u);
      },
      parseOpera9: function(u) {
        for (var c = /Line (\d+).*script (?:in )?(\S+)/i, l = u.message.split(`
`), f = [], d = 2, _ = l.length; d < _; d += 2) {
          var E = c.exec(l[d]);
          E && f.push(new n({
            fileName: E[2],
            lineNumber: E[1],
            source: l[d]
          }));
        }
        return f;
      },
      parseOpera10: function(u) {
        for (var c = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = u.stacktrace.split(`
`), f = [], d = 0, _ = l.length; d < _; d += 2) {
          var E = c.exec(l[d]);
          E && f.push(
            new n({
              functionName: E[3] || void 0,
              fileName: E[2],
              lineNumber: E[1],
              source: l[d]
            })
          );
        }
        return f;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(u) {
        var c = u.stack.split(`
`).filter(function(l) {
          return !!l.match(i) && !l.match(/^Error created at/);
        }, this);
        return c.map(function(l) {
          var f = l.split("@"), d = this.extractLocation(f.pop()), _ = f.shift() || "", E = _.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, p;
          _.match(/\(([^)]*)\)/) && (p = _.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var v = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new n({
            functionName: E,
            args: v,
            fileName: d[0],
            lineNumber: d[1],
            columnNumber: d[2],
            source: l
          });
        }, this);
      }
    };
  });
})(Jn);
var No = Jn.exports;
const at = /* @__PURE__ */ Kn(No);
function Lo(e, t, r) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], i = r(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = i, () => {
      e[t] = n;
    };
  } catch (n) {
    return () => {
    };
  }
}
function bo(e) {
  if (!e || !e.outerHTML)
    return "";
  let t = "";
  for (; e.parentElement; ) {
    let r = e.localName;
    if (!r)
      break;
    r = r.toLowerCase();
    let n = e.parentElement, i = [];
    if (n.children && n.children.length > 0)
      for (let o = 0; o < n.children.length; o++) {
        let a = n.children[o];
        a.localName && a.localName.toLowerCase && a.localName.toLowerCase() === r && i.push(a);
      }
    i.length > 1 && (r += ":eq(" + i.indexOf(e) + ")"), t = r + (t ? ">" + t : ""), e = n;
  }
  return t;
}
function or(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Qn(e, t) {
  if (t === 0)
    return !0;
  const r = Object.keys(e);
  for (const n of r)
    if (or(e[n]) && Qn(e[n], t - 1))
      return !0;
  return !1;
}
function Ct(e, t) {
  const r = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(r, t);
  const n = [], i = [];
  return JSON.stringify(e, function(s, u) {
    if (n.length > 0) {
      const c = n.indexOf(this);
      ~c ? n.splice(c + 1) : n.push(this), ~c ? i.splice(c, 1 / 0, s) : i.push(s), ~n.indexOf(u) && (n[0] === u ? u = "[Circular ~]" : u = "[Circular ~." + i.slice(0, n.indexOf(u)).join(".") + "]");
    } else
      n.push(u);
    if (u == null)
      return u;
    if (o(u))
      return a(u);
    if (u instanceof Event) {
      const c = {};
      for (const l in u) {
        const f = u[l];
        Array.isArray(f) ? c[l] = bo(f.length ? f[0] : null) : c[l] = f;
      }
      return c;
    } else {
      if (u instanceof Node)
        return u instanceof HTMLElement ? u ? u.outerHTML : "" : u.nodeName;
      if (u instanceof Error)
        return u.name + ": " + u.message;
    }
    return u;
  });
  function o(s) {
    return or(s) && Object.keys(s).length > r.numOfKeysLimit || typeof s == "function" ? !0 : s instanceof Event && s.isTrusted === !1 ? Object.keys(s).length === 1 : !!(or(s) && Qn(s, r.depthOfLimit));
  }
  function a(s) {
    let u = s.toString();
    return r.stringLengthLimit && u.length > r.stringLengthLimit && (u = `${u.slice(0, r.stringLengthLimit)}...`), u;
  }
}
function wo() {
  var e = document.createElement("canvas");
  return e.getContext && e.getContext("2d") ? e.toDataURL("image/webp").indexOf("data:image/webp") == 0 : !1;
}
function Np() {
  return wo() ? {
    type: "image/webp",
    quality: 0.9
  } : {
    type: "image/jpeg",
    quality: 0.6
  };
}
function Io(e, t) {
  const r = t.logger;
  let n;
  n = window[r];
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (s) => {
      const { message: u, error: c } = s;
      let l = [];
      c && (l = at.parse(c));
      const f = [
        Ct(u, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: f
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, s) {
    return a[s] ? Lo(a, s, (u) => (...c) => {
      u.apply(this, c);
      try {
        const l = at.parse(new Error()), f = t.serializeConsoleAttributes ? c.map((d) => typeof d == "object" ? Ct(d, t.stringifyOptions) : d) : c.filter((d) => typeof d != "object").map((d) => `${d}`);
        e({
          type: s,
          trace: l.slice(1),
          value: f,
          attributes: Ct(c.filter((d) => typeof d == "object").reduce((d, _) => D(D({}, d), _), {}), t.stringifyOptions),
          time: Date.now()
        });
      } catch (l) {
        u("highlight logger error:", l, ...c);
      }
    }) : () => {
    };
  }
}
var ar = { exports: {} };
(function(e, t) {
  t = e.exports = r, t.getSerialize = n;
  function r(i, o, a, s) {
    return JSON.stringify(i, n(o, s), a);
  }
  function n(i, o) {
    var a = [], s = [];
    return o == null && (o = function(u, c) {
      return a[0] === c ? "[Circular ~]" : "[Circular ~." + s.slice(0, a.indexOf(c)).join(".") + "]";
    }), function(u, c) {
      if (a.length > 0) {
        var l = a.indexOf(this);
        ~l ? a.splice(l + 1) : a.push(this), ~l ? s.splice(l, 1 / 0, u) : s.push(u), ~a.indexOf(c) && (c = o.call(this, u, c));
      } else a.push(c);
      return i == null ? c : i.call(this, u, c);
    };
  }
})(ar, ar.exports);
var Po = ar.exports;
const st = /* @__PURE__ */ Kn(Po);
function xt(e, t, r, n) {
  var s, u, c, l;
  let i = [];
  try {
    i = at.parse(n != null ? n : t);
  } catch (f) {
    i = at.parse(new Error());
  }
  let o = {};
  t instanceof Error && (t = t.message, t.cause && (o = { "exception.cause": t.cause }));
  const a = xo(i);
  e({
    event: st(t),
    type: "window.onerror",
    url: window.location.href,
    source: r != null ? r : "",
    lineNumber: (s = a[0]) != null && s.lineNumber ? (u = a[0]) == null ? void 0 : u.lineNumber : 0,
    columnNumber: (c = a[0]) != null && c.columnNumber ? (l = a[0]) == null ? void 0 : l.columnNumber : 0,
    stackTrace: a,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: o ? st(o) : void 0
  });
}
const Co = (e, { enablePromisePatch: t }) => {
  if (typeof window == "undefined")
    return () => {
    };
  const r = window.onerror = (a, s, u, c, l) => {
    xt(e, a, s, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const s = a.promise;
      s.getStack ? xt(e, a.reason, a.type, s.getStack()) : xt(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(u) {
      super(u);
      S(this, "promiseCreationError");
      this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const u = typeof window.Zone == "undefined";
      return t && u;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, xo = (e) => {
  var r, n;
  if (e.length === 0)
    return e;
  const t = e[0];
  return (r = t.fileName) != null && r.includes("highlight.run") || (n = t.fileName) != null && n.includes("highlight.io") || t.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Qr = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Zr = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var Do = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, ie = "1.9.0", en = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function Mo(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(en);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(u) {
      return u === e;
    };
  function o(s) {
    return r.add(s), !1;
  }
  function a(s) {
    return t.add(s), !0;
  }
  return function(u) {
    if (t.has(u))
      return !0;
    if (r.has(u))
      return !1;
    var c = u.match(en);
    if (!c)
      return o(u);
    var l = {
      major: +c[1],
      minor: +c[2],
      patch: +c[3],
      prerelease: c[4]
    };
    return l.prerelease != null || i.major !== l.major ? o(u) : i.major === 0 ? i.minor === l.minor && i.patch <= l.patch ? a(u) : o(u) : i.minor <= l.minor ? a(u) : o(u);
  };
}
var ko = Mo(ie), Uo = ie.split(".")[0], Ue = Symbol.for("opentelemetry.js.api." + Uo), Be = Do;
function je(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = Be[Ue] = (i = Be[Ue]) !== null && i !== void 0 ? i : {
    version: ie
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== ie) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + ie);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + ie + "."), !0;
}
function ae(e) {
  var t, r, n = (t = Be[Ue]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !ko(n)))
    return (r = Be[Ue]) === null || r === void 0 ? void 0 : r[e];
}
function Ve(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + ie + ".");
  var r = Be[Ue];
  r && delete r[e];
}
var Bo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ho = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Fo = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ae("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ae("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ae("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ae("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ae("verbose", this._namespace, t);
    }, e;
  }()
);
function Ae(e, t, r) {
  var n = ae("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, Ho([], Bo(r), !1));
}
var A;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(A || (A = {}));
function Go(e, t) {
  e < A.NONE ? e = A.NONE : e > A.ALL && (e = A.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", A.ERROR),
    warn: r("warn", A.WARN),
    info: r("info", A.INFO),
    debug: r("debug", A.DEBUG),
    verbose: r("verbose", A.VERBOSE)
  };
}
var jo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Vo = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, $o = "diag", V = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var s = ae("diag");
          if (s)
            return s[i].apply(s, Vo([], jo(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, s, u;
        if (o === void 0 && (o = { logLevel: A.INFO }), i === r) {
          var c = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = c.stack) !== null && a !== void 0 ? a : c.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = ae("diag"), f = Go((s = o.logLevel) !== null && s !== void 0 ? s : A.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var d = (u = new Error().stack) !== null && u !== void 0 ? u : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + d), f.warn("Current logger will overwrite one already registered from " + d);
        }
        return je("diag", f, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        Ve($o, r);
      }, r.createComponentLogger = function(i) {
        return new Fo(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), Xo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, qo = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zo = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = Xo(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = qo(n), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          o._entries.delete(u);
        }
      } catch (c) {
        t = { error: c };
      } finally {
        try {
          s && !s.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), Yo = Symbol("BaggageEntryMetadata"), Wo = V.instance();
function Ko(e) {
  return e === void 0 && (e = {}), new zo(new Map(Object.entries(e)));
}
function Cr(e) {
  return typeof e != "string" && (Wo.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: Yo,
    toString: function() {
      return e;
    }
  };
}
function gt(e) {
  return Symbol.for(e);
}
var Jo = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), te = new Jo(), ue = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Qo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return ua;
    }, e.prototype.createHistogram = function(t, r) {
      return ca;
    }, e.prototype.createCounter = function(t, r) {
      return sa;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return la;
    }, e.prototype.createObservableGauge = function(t, r) {
      return da;
    }, e.prototype.createObservableCounter = function(t, r) {
      return fa;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return pa;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), mt = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Zo = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(mt)
), ea = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(mt)
), ta = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(mt)
), ra = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(mt)
), xr = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), na = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(xr)
), ia = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(xr)
), oa = (
  /** @class */
  function(e) {
    ue(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(xr)
), aa = new Qo(), sa = new Zo(), ua = new ta(), ca = new ra(), la = new ea(), fa = new na(), da = new ia(), pa = new oa(), _a = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, ha = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, Ea = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ta = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, va = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return te;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, Ta([n], Ea(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), ga = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ma = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Dt = "context", ya = new va(), yt = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return je(Dt, t, V.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, ma([t, r, n], ga(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return ae(Dt) || ya;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), Ve(Dt, V.instance());
    }, e;
  }()
), $;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})($ || ($ = {}));
var Zn = "0000000000000000", ei = "00000000000000000000000000000000", ti = {
  traceId: ei,
  spanId: Zn,
  traceFlags: $.NONE
}, xe = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = ti), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), Dr = gt("OpenTelemetry Context Key SPAN");
function Mr(e) {
  return e.getValue(Dr) || void 0;
}
function Oa() {
  return Mr(yt.getInstance().active());
}
function kr(e, t) {
  return e.setValue(Dr, t);
}
function Sa(e) {
  return e.deleteValue(Dr);
}
function Ra(e, t) {
  return kr(e, new xe(t));
}
function ri(e) {
  var t;
  return (t = Mr(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Aa = /^([0-9a-f]{32})$/i, Na = /^[0-9a-f]{16}$/i;
function ni(e) {
  return Aa.test(e) && e !== ei;
}
function La(e) {
  return Na.test(e) && e !== Zn;
}
function $e(e) {
  return ni(e.traceId) && La(e.spanId);
}
function ba(e) {
  return new xe(e);
}
var Mt = yt.getInstance(), ii = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = Mt.active());
      var i = !!(r != null && r.root);
      if (i)
        return new xe();
      var o = n && ri(n);
      return wa(o) && $e(o) ? new xe(o) : new xe();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, s;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? s = r : arguments.length === 3 ? (o = r, s = n) : (o = r, a = n, s = i);
        var u = a != null ? a : Mt.active(), c = this.startSpan(t, o, u), l = kr(u, c);
        return Mt.with(l, s, void 0, c);
      }
    }, e;
  }()
);
function wa(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Ia = new ii(), Pa = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Ia;
    }, e;
  }()
), Ca = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new ii();
    }, e;
  }()
), xa = new Ca(), tn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Pa(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : xa;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), ut;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(ut || (ut = {}));
var He;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})(He || (He = {}));
var sr;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(sr || (sr = {}));
var N = yt.getInstance(), y = V.instance(), Da = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return aa;
    }, e;
  }()
), Ma = new Da(), kt = "metrics", ka = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return je(kt, t, V.instance());
    }, e.prototype.getMeterProvider = function() {
      return ae(kt) || Ma;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      Ve(kt, V.instance());
    }, e;
  }()
), oi = ka.getInstance(), Ua = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Ur = gt("OpenTelemetry Baggage Key");
function ai(e) {
  return e.getValue(Ur) || void 0;
}
function Ba() {
  return ai(yt.getInstance().active());
}
function Ha(e, t) {
  return e.setValue(Ur, t);
}
function Fa(e) {
  return e.deleteValue(Ur);
}
var Ut = "propagation", Ga = new Ua(), ja = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = Ko, this.getBaggage = ai, this.getActiveBaggage = Ba, this.setBaggage = Ha, this.deleteBaggage = Fa;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return je(Ut, t, V.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = ha), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = _a), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      Ve(Ut, V.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return ae(Ut) || Ga;
    }, e;
  }()
), M = ja.getInstance(), Bt = "trace", Va = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new tn(), this.wrapSpanContext = ba, this.isSpanContextValid = $e, this.deleteSpan = Sa, this.getSpan = Mr, this.getActiveSpan = Oa, this.getSpanContext = ri, this.setSpan = kr, this.setSpanContext = Ra;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = je(Bt, this._proxyTracerProvider, V.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return ae(Bt) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      Ve(Bt, V.instance()), this._proxyTracerProvider = new tn();
    }, e;
  }()
), L = Va.getInstance(), $a = gt("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function si(e) {
  return e.getValue($a) === !0;
}
var Xa = "=", ur = ";", cr = ",", Ht = "baggage", qa = 180, za = 4096, Ya = 8192, Wa = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ka(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? cr : "") + r;
    return n.length > Ya ? t : n;
  }, "");
}
function Ja(e) {
  return e.getAllEntries().map(function(t) {
    var r = Wa(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += ur + i.metadata.toString()), o;
  });
}
function Qa(e) {
  var t = e.split(ur);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(Xa);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Cr(t.join(ur))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Za = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = M.getBaggage(t);
      if (!(!i || si(t))) {
        var o = Ja(i).filter(function(s) {
          return s.length <= za;
        }).slice(0, qa), a = Ka(o);
        a.length > 0 && n.set(r, Ht, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, Ht), o = Array.isArray(i) ? i.join(cr) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var s = o.split(cr);
      return s.forEach(function(u) {
        var c = Qa(u);
        if (c) {
          var l = { value: c.value };
          c.metadata && (l.metadata = c.metadata), a[c.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : M.setBaggage(t, M.createBaggage(a));
    }, e.prototype.fields = function() {
      return [Ht];
    }, e;
  }()
), ct = performance, es = "1.27.0", ts = "exception.type", rs = "exception.message", ns = "exception.stacktrace", is = "http.method", os = "http.url", as = "http.host", ss = "http.scheme", us = "http.status_code", cs = "http.user_agent", ls = "http.response_content_length", fs = "http.response_content_length_uncompressed", Ft = ts, Gt = rs, ds = ns, ui = is, De = os, ci = as, li = ss, fi = us, Br = cs, ps = ls, _s = fs, hs = "deployment.environment", Es = "process.runtime.name", Ts = "service.name", vs = "telemetry.sdk.name", gs = "telemetry.sdk.language", ms = "telemetry.sdk.version", ys = hs, di = Es, pi = Ts, Ee = vs, Te = gs, ve = ms, Os = "webjs", _i = Os, Ss = "service.name", Rs = "url.full", As = "url.path", Ns = "url.query", ce, jt = (ce = {}, ce[Ee] = "opentelemetry", ce[di] = "browser", ce[Te] = _i, ce[ve] = es, ce), Ls = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, bs = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Ls(this._propagators), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          try {
            u.inject(t, r, n);
          } catch (c) {
            y.warn("Failed to inject with " + u.constructor.name + ". Err: " + c.message);
          }
        }
      } catch (c) {
        i = { error: c };
      } finally {
        try {
          s && !s.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          y.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), lr = "[_0-9a-z-*/]", ws = "[a-z]" + lr + "{0,255}", Is = "[a-z0-9]" + lr + "{0,240}@[a-z]" + lr + "{0,13}", Ps = new RegExp("^(?:" + ws + "|" + Is + ")$"), Cs = /^[ -~]{0,255}[!-~]$/, xs = /,|=/;
function Ds(e) {
  return Ps.test(e);
}
function Ms(e) {
  return Cs.test(e) && !xs.test(e);
}
var rn = 32, ks = 512, nn = ",", on = "=", Us = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + on + t.get(n)), r;
      }, []).join(nn);
    }, e.prototype._parse = function(t) {
      t.length > ks || (this._internalState = t.split(nn).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(on);
        if (o !== -1) {
          var a = i.slice(0, o), s = i.slice(o + 1, n.length);
          Ds(a) && Ms(s) && r.set(a, s);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > rn && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, rn))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), et = "traceparent", Vt = "tracestate", Bs = "00", Hs = "(?!ff)[\\da-f]{2}", Fs = "(?![0]{32})[\\da-f]{32}", Gs = "(?![0]{16})[\\da-f]{16}", js = "[\\da-f]{2}", Vs = new RegExp("^\\s?(" + Hs + ")-(" + Fs + ")-(" + Gs + ")-(" + js + ")(-.*)?\\s?$");
function $s(e) {
  var t = Vs.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Xs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = L.getSpanContext(t);
      if (!(!i || si(t) || !$e(i))) {
        var o = Bs + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || $.NONE).toString(16);
        n.set(r, et, o), i.traceState && n.set(r, Vt, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, et);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = $s(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var s = n.get(r, Vt);
      if (s) {
        var u = Array.isArray(s) ? s.join(",") : s;
        a.traceState = new Us(typeof u == "string" ? u : void 0);
      }
      return L.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [et, Vt];
    }, e;
  }()
), qs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), zs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new qs();
    }, e;
  }()
), an = new zs(), Ys = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Ye = Symbol.for("io.opentelemetry.js.api.logs"), Ne = Ys;
function Ws(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var sn = 1, Ks = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return Ne[Ye] ? this.getLoggerProvider() : (Ne[Ye] = Ws(sn, t, an), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = Ne[Ye]) === null || t === void 0 ? void 0 : t.call(Ne, sn)) !== null && r !== void 0 ? r : an;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete Ne[Ye];
    }, e;
  }()
), hi = Ks.getInstance();
function Js(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function Qs(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function Zs(e) {
  var t, r, n = e.tracerProvider || L.getTracerProvider(), i = e.meterProvider || oi.getMeterProvider(), o = e.loggerProvider || hi.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Js(a, n, i, o), function() {
    Qs(a);
  };
}
function fr(e) {
  return typeof e == "function";
}
var k = console.error.bind(console);
function Le(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Xe(e) {
  e && e.logger && (fr(e.logger) ? k = e.logger : k("new logger isn't a function, not replacing"));
}
function Ei(e, t, r) {
  if (!e || !e[t]) {
    k("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    k("no wrapper function"), k(new Error().stack);
    return;
  }
  if (!fr(e[t]) || !fr(r)) {
    k("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return Le(i, "__original", n), Le(i, "__unwrap", function() {
    e[t] === i && Le(e, t, n);
  }), Le(i, "__wrapped", !0), Le(e, t, i), i;
}
function eu(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    k("must provide one or more modules to patch"), k(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    k("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      Ei(n, i, r);
    });
  });
}
function Ti(e, t) {
  if (!e || !e[t]) {
    k("no function to unwrap."), k(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    k("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function tu(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    k("must provide one or more modules to patch"), k(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    k("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      Ti(r, n);
    });
  });
}
Xe.wrap = Ei;
Xe.massWrap = eu;
Xe.unwrap = Ti;
Xe.massUnwrap = tu;
var We = Xe, dr = function() {
  return dr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, dr.apply(this, arguments);
}, ru = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = We.wrap, this._unwrap = We.unwrap, this._massWrap = We.massWrap, this._massUnwrap = We.massUnwrap, this.setConfig(n), this._diag = y.createComponentLogger({
        namespace: t
      }), this._tracer = L.getTracer(t, r), this._meter = oi.getMeter(t, r), this._logger = hi.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = dr({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), nu = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ot = (
  /** @class */
  function(e) {
    nu(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(ru)
);
function lt(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    if (t(n, i), n && !r)
      throw n;
    return i;
  }
}
function oe(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var vi = gt("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function iu(e) {
  return e.setValue(vi, !0);
}
function Hr(e) {
  return e.getValue(vi) === !0;
}
var ou = "=", pr = ";", _r = ",", $t = "baggage", au = 180, su = 4096, uu = 8192, cu = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function lu(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? _r : "") + r;
    return n.length > uu ? t : n;
  }, "");
}
function fu(e) {
  return e.getAllEntries().map(function(t) {
    var r = cu(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += pr + i.metadata.toString()), o;
  });
}
function du(e) {
  var t = e.split(pr);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(ou);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Cr(t.join(pr))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var pu = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = M.getBaggage(t);
      if (!(!i || Hr(t))) {
        var o = fu(i).filter(function(s) {
          return s.length <= su;
        }).slice(0, au), a = lu(o);
        a.length > 0 && n.set(r, $t, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, $t), o = Array.isArray(i) ? i.join(_r) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var s = o.split(_r);
      return s.forEach(function(u) {
        var c = du(u);
        if (c) {
          var l = { value: c.value };
          c.metadata && (l.metadata = c.metadata), a[c.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : M.setBaggage(t, M.createBaggage(a));
    }, e.prototype.fields = function() {
      return [$t];
    }, e;
  }()
), gi = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, _u = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function tt(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = gi(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = _u(o.value, 2), s = a[0], u = a[1];
      if (!hu(s)) {
        y.warn("Invalid attribute key: " + s);
        continue;
      }
      if (!mi(u)) {
        y.warn("Invalid attribute value set for key: " + s);
        continue;
      }
      Array.isArray(u) ? n[s] = u.slice() : n[s] = u;
    }
  } catch (c) {
    t = { error: c };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function hu(e) {
  return typeof e == "string" && e.length > 0;
}
function mi(e) {
  return e == null ? !0 : Array.isArray(e) ? Eu(e) : yi(e);
}
function Eu(e) {
  var t, r, n;
  try {
    for (var i = gi(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (yi(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function yi(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Tu() {
  return function(e) {
    y.error(vu(e));
  };
}
function vu(e) {
  return typeof e == "string" ? e : JSON.stringify(gu(e));
}
function gu(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var mu = Tu();
function ft(e) {
  try {
    mu(e);
  } catch (t) {
  }
}
var j;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(j || (j = {}));
var yu = ",", Ou = ["OTEL_SDK_DISABLED"];
function Su(e) {
  return Ou.indexOf(e) > -1;
}
var Ru = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function Au(e) {
  return Ru.indexOf(e) > -1;
}
var Nu = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS"
];
function Lu(e) {
  return Nu.indexOf(e) > -1;
}
var rt = 1 / 0, nt = 128, bu = 128, wu = 128, Oi = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: A.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: rt,
  OTEL_ATTRIBUTE_COUNT_LIMIT: nt,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: rt,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: nt,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: rt,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: nt,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: bu,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: wu,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: j.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function Iu(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function Pu(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function Cu(e, t, r, n) {
  n === void 0 && (n = yu);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var xu = {
  ALL: A.ALL,
  VERBOSE: A.VERBOSE,
  DEBUG: A.DEBUG,
  INFO: A.INFO,
  WARN: A.WARN,
  ERROR: A.ERROR,
  NONE: A.NONE
};
function Du(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = xu[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function Si(e) {
  var t = {};
  for (var r in Oi) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Du(n, t, e);
        break;
      default:
        if (Su(n))
          Iu(n, t, e);
        else if (Au(n))
          Pu(n, t, e);
        else if (Lu(n))
          Cu(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var Ri = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function ge() {
  var e = Si(Ri);
  return Object.assign({}, Oi, e);
}
function Mu() {
  return Si(Ri);
}
var _e = performance, ku = "1.26.0", le, Xt = (le = {}, le[Ee] = "opentelemetry", le[di] = "browser", le[Te] = _i, le[ve] = ku, le), Uu = 9, Bu = 6, Hu = Math.pow(10, Bu), dt = Math.pow(10, Uu);
function J(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Hu);
  return [r, n];
}
function Fr() {
  var e = _e.timeOrigin;
  if (typeof e != "number") {
    var t = _e;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Ai(e) {
  var t = J(Fr()), r = J(typeof e == "number" ? e : _e.now());
  return Ni(t, r);
}
function Me(e) {
  if (Gr(e))
    return e;
  if (typeof e == "number")
    return e < Fr() ? Ai(e) : J(e);
  if (e instanceof Date)
    return J(e.getTime());
  throw TypeError("Invalid input type");
}
function Fu(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += dt), [r, n];
}
function Q(e) {
  return e[0] * dt + e[1];
}
function Gr(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function un(e) {
  return Gr(e) || typeof e == "number" || e instanceof Date;
}
function Ni(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= dt && (r[1] -= dt, r[0] += 1), r;
}
var hr;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(hr || (hr = {}));
var Gu = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, ju = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Gu(this._propagators), s = a.next(); !s.done; s = a.next()) {
          var u = s.value;
          try {
            u.inject(t, r, n);
          } catch (c) {
            y.warn("Failed to inject with " + u.constructor.name + ". Err: " + c.message);
          }
        }
      } catch (c) {
        i = { error: c };
      } finally {
        try {
          s && !s.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          y.warn("Failed to inject with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), Er = "[_0-9a-z-*/]", Vu = "[a-z]" + Er + "{0,255}", $u = "[a-z0-9]" + Er + "{0,240}@[a-z]" + Er + "{0,13}", Xu = new RegExp("^(?:" + Vu + "|" + $u + ")$"), qu = /^[ -~]{0,255}[!-~]$/, zu = /,|=/;
function Yu(e) {
  return Xu.test(e);
}
function Wu(e) {
  return qu.test(e) && !zu.test(e);
}
var cn = 32, Ku = 512, ln = ",", fn = "=", Ju = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + fn + t.get(n)), r;
      }, []).join(ln);
    }, e.prototype._parse = function(t) {
      t.length > Ku || (this._internalState = t.split(ln).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(fn);
        if (o !== -1) {
          var a = i.slice(0, o), s = i.slice(o + 1, n.length);
          Yu(a) && Wu(s) && r.set(a, s);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > cn && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, cn))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), qt = "traceparent", zt = "tracestate", Qu = "00", Zu = "(?!ff)[\\da-f]{2}", ec = "(?![0]{32})[\\da-f]{32}", tc = "(?![0]{16})[\\da-f]{16}", rc = "[\\da-f]{2}", nc = new RegExp("^\\s?(" + Zu + ")-(" + ec + ")-(" + tc + ")-(" + rc + ")(-.*)?\\s?$");
function ic(e) {
  var t = nc.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var oc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = L.getSpanContext(t);
      if (!(!i || Hr(t) || !$e(i))) {
        var o = Qu + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || $.NONE).toString(16);
        n.set(r, qt, o), i.traceState && n.set(r, zt, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, qt);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = ic(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var s = n.get(r, zt);
      if (s) {
        var u = Array.isArray(s) ? s.join(",") : s;
        a.traceState = new Ju(typeof u == "string" ? u : void 0);
      }
      return L.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [qt, zt];
    }, e;
  }()
), ac = "[object Object]", sc = "[object Null]", uc = "[object Undefined]", cc = Function.prototype, Li = cc.toString, lc = Li.call(Object), fc = dc(Object.getPrototypeOf, Object), bi = Object.prototype, wi = bi.hasOwnProperty, re = Symbol ? Symbol.toStringTag : void 0, Ii = bi.toString;
function dc(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function dn(e) {
  if (!pc(e) || _c(e) !== ac)
    return !1;
  var t = fc(e);
  if (t === null)
    return !0;
  var r = wi.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Li.call(r) === lc;
}
function pc(e) {
  return e != null && typeof e == "object";
}
function _c(e) {
  return e == null ? e === void 0 ? uc : sc : re && re in Object(e) ? hc(e) : Ec(e);
}
function hc(e) {
  var t = wi.call(e, re), r = e[re], n = !1;
  try {
    e[re] = void 0, n = !0;
  } catch (o) {
  }
  var i = Ii.call(e);
  return n && (t ? e[re] = r : delete e[re]), i;
}
function Ec(e) {
  return Ii.call(e);
}
var Tc = 20;
function vc() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = Pi(r, e.shift(), 0, n);
  return r;
}
function Yt(e) {
  return pt(e) ? e.slice() : e;
}
function Pi(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Tc)) {
    if (r++, it(e) || it(t) || Ci(t))
      i = Yt(t);
    else if (pt(e)) {
      if (i = e.slice(), pt(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Yt(t[o]));
      else if (be(t))
        for (var s = Object.keys(t), o = 0, a = s.length; o < a; o++) {
          var u = s[o];
          i[u] = Yt(t[u]);
        }
    } else if (be(e))
      if (be(t)) {
        if (!gc(e, t))
          return t;
        i = Object.assign({}, e);
        for (var s = Object.keys(t), o = 0, a = s.length; o < a; o++) {
          var u = s[o], c = t[u];
          if (it(c))
            typeof c == "undefined" ? delete i[u] : i[u] = c;
          else {
            var l = i[u], f = c;
            if (pn(e, u, n) || pn(t, u, n))
              delete i[u];
            else {
              if (be(l) && be(f)) {
                var d = n.get(l) || [], _ = n.get(f) || [];
                d.push({ obj: e, key: u }), _.push({ obj: t, key: u }), n.set(l, d), n.set(f, _);
              }
              i[u] = Pi(i[u], c, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function pn(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function pt(e) {
  return Array.isArray(e);
}
function Ci(e) {
  return typeof e == "function";
}
function be(e) {
  return !it(e) && !pt(e) && !Ci(e) && typeof e == "object";
}
function it(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "undefined" || e instanceof Date || e instanceof RegExp || e === null;
}
function gc(e, t) {
  return !(!dn(e) || !dn(t));
}
function mc(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
var yc = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Oc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Sc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Rc = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new yc();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, Sc([this._that], Oc(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), Ac = "exception", Nc = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, _n = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Lc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, bc = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, s, u, c, l) {
      s === void 0 && (s = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: sr.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = s;
      var f = Date.now();
      this._performanceStartTime = _e.now(), this._performanceOffset = f - (this._performanceStartTime + Fr()), this._startTimeProvided = u != null, this.startTime = this._getTime(u != null ? u : f), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (y.warn("Invalid attribute key: " + t), this) : mi(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (y.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = Nc(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = _n(o.value, 2), s = a[0], u = a[1];
          this.setAttribute(s, u);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return y.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && y.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), un(r) && (un(n) || (n = r), r = void 0);
      var i = tt(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, Lc([], _n(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = t, this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        y.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = Fu(this.startTime, this.endTime), this._duration[0] < 0 && (y.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && y.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t < _e.now())
        return Ai(t + this._performanceOffset);
      if (typeof t == "number")
        return J(t);
      if (t instanceof Date)
        return J(t.getTime());
      if (Gr(t))
        return t;
      if (this._startTimeProvided)
        return J(Date.now());
      var r = _e.now() - this._performanceStartTime;
      return Ni(this.startTime, J(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[Gt] = t : t && (t.code ? n[Ft] = t.code.toString() : t.name && (n[Ft] = t.name), t.message && (n[Gt] = t.message), t.stack && (n[ds] = t.stack)), n[Ft] || n[Gt] ? this.addEvent(Ac, n, r) : y.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && y.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substr(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (y.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), me;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(me || (me = {}));
var _t = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: me.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), he = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: me.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), Wt = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (ft(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new he()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new he(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new _t(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new he(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new _t();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var s = L.getSpanContext(t);
      return !s || !$e(s) ? this._root.shouldSample(t, r, n, i, o, a) : s.isRemote ? s.traceFlags & $.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : s.traceFlags & $.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), hn = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: ni(r) && this._accumulate(r) < this._upperBound ? me.RECORD_AND_SAMPLED : me.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), wc = ge(), Ic = j.AlwaysOn, fe = 1;
function xi() {
  var e = ge();
  return {
    sampler: Di(wc),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    }
  };
}
function Di(e) {
  switch (e === void 0 && (e = ge()), e.OTEL_TRACES_SAMPLER) {
    case j.AlwaysOn:
      return new he();
    case j.AlwaysOff:
      return new _t();
    case j.ParentBasedAlwaysOn:
      return new Wt({
        root: new he()
      });
    case j.ParentBasedAlwaysOff:
      return new Wt({
        root: new _t()
      });
    case j.TraceIdRatio:
      return new hn(En(e));
    case j.ParentBasedTraceIdRatio:
      return new Wt({
        root: new hn(En(e))
      });
    default:
      return y.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + Ic + '".'), new he();
  }
}
function En(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return y.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + fe + "."), fe;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (y.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + fe + "."), fe) : t < 0 || t > 1 ? (y.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + fe + "."), fe) : t;
}
function Pc(e) {
  var t = {
    sampler: Di()
  }, r = xi(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function Cc(e) {
  var t, r, n, i, o, a, s, u, c, l, f, d, _ = Object.assign({}, e.spanLimits), E = Mu();
  return _.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : E.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : E.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : nt, _.attributeValueLengthLimit = (d = (f = (l = (u = (s = e.spanLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && u !== void 0 ? u : (c = e.generalLimits) === null || c === void 0 ? void 0 : c.attributeValueLengthLimit) !== null && l !== void 0 ? l : E.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : E.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && d !== void 0 ? d : rt, Object.assign({}, e, { spanLimits: _ });
}
var xc = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = ge();
      this._maxExportBatchSize = typeof (r == null ? void 0 : r.maxExportBatchSize) == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof (r == null ? void 0 : r.maxQueueSize) == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof (r == null ? void 0 : r.scheduledDelayMillis) == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof (r == null ? void 0 : r.exportTimeoutMillis) == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new Rc(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (y.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & $.SAMPLED && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && y.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (y.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, s = o; a < s; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        N.with(iu(N.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(f) {
              var d;
              clearTimeout(i), f.code === hr.SUCCESS ? r() : n((d = f.error) !== null && d !== void 0 ? d : new Error("BatchSpanProcessor: span export failed"));
            });
          }, s = null, u = 0, c = o.length; u < c; u++) {
            var l = o[u];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (s != null || (s = []), s.push(l.resource.waitForAsyncAttributes()));
          }
          s === null ? a() : Promise.all(s).then(a, function(f) {
            ft(f), n(f);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, ft(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Dc = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Mi = (
  /** @class */
  function(e) {
    Dc(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      (r == null ? void 0 : r.disableAutoFlushOnDocumentHide) !== !0 && typeof document != "undefined" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush();
      }, this._pageHideListener = function() {
        n.forceFlush();
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document != "undefined" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(xc)
), Mc = 8, kc = 16, Uc = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = Tn(kc), this.generateSpanId = Tn(Mc);
    }
    return e;
  }()
), Ke = Array(32);
function Tn(e) {
  return function() {
    for (var r = 0; r < e * 2; r++)
      Ke[r] = Math.floor(Math.random() * 16) + 48, Ke[r] >= 58 && (Ke[r] += 39);
    return String.fromCharCode.apply(null, Ke.slice(0, e * 2));
  };
}
var Bc = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = Pc(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new Uc(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = N.active()), r.root && (n = L.deleteSpan(n));
      var s = L.getSpan(n);
      if (Hr(n)) {
        y.debug("Instrumentation suppressed, returning Noop Span");
        var u = L.wrapSpanContext(ti);
        return u;
      }
      var c = s == null ? void 0 : s.spanContext(), l = this._idGenerator.generateSpanId(), f, d, _;
      !c || !L.isSpanContextValid(c) ? f = this._idGenerator.generateTraceId() : (f = c.traceId, d = c.traceState, _ = c.spanId);
      var E = (i = r.kind) !== null && i !== void 0 ? i : He.INTERNAL, p = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(U) {
        return {
          context: U.context,
          attributes: tt(U.attributes)
        };
      }), v = tt(r.attributes), T = this._sampler.shouldSample(n, f, t, E, v, p);
      d = (a = T.traceState) !== null && a !== void 0 ? a : d;
      var O = T.decision === ut.RECORD_AND_SAMPLED ? $.SAMPLED : $.NONE, b = { traceId: f, spanId: l, traceFlags: O, traceState: d };
      if (T.decision === ut.NOT_RECORD) {
        y.debug("Recording is off, propagating context in a non-recording span");
        var u = L.wrapSpanContext(b);
        return u;
      }
      var I = tt(Object.assign(v, T.attributes)), H = new bc(this, n, t, b, E, _, p, r.startTime, void 0, I);
      return H;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, s;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? s = r : arguments.length === 3 ? (o = r, s = n) : (o = r, a = n, s = i);
        var u = a != null ? a : N.active(), c = this.startSpan(t, o, u), l = L.setSpan(u, c);
        return N.with(l, s, void 0, c);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
);
function Hc() {
  return "unknown_service";
}
var Y = function() {
  return Y = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Y.apply(this, arguments);
}, Fc = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, Gc = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, jc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, vn = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return y.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[pi] = Hc(), t[Te] = Xt[Te], t[Ee] = Xt[Ee], t[ve] = Xt[ve], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && y.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Fc(this, void 0, void 0, function() {
        return Gc(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = Y(Y({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var s, u = jc(a, 2), c = u[0], l = u[1];
        return Y(Y(Y(Y({}, r._syncAttributes), c), (s = t._syncAttributes) !== null && s !== void 0 ? s : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), Je = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Vc = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = Je(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(s) {
        Promise.all(n).then(function() {
          s();
        }).catch(function(u) {
          ft(u || new Error("MultiSpanProcessor: forceFlush failed")), s();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = Je(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var s = a.value;
          s.onStart(t, r);
        }
      } catch (u) {
        n = { error: u };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = Je(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = Je(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(s, u) {
        Promise.all(n).then(function() {
          s();
        }, u);
      });
    }, e;
  }()
), $c = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), ne;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(ne || (ne = {}));
var Xc = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var n = vc({}, xi(), Cc(t));
      this.resource = (r = n.resource) !== null && r !== void 0 ? r : vn.empty(), this.resource = vn.default().merge(this.resource), this._config = Object.assign({}, n, {
        resource: this.resource
      });
      var i = this._buildExporterFromEnv();
      if (i !== void 0) {
        var o = new Mi(i);
        this.activeSpanProcessor = o;
      } else
        this.activeSpanProcessor = new $c();
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + ((n == null ? void 0 : n.schemaUrl) || "");
      return this._tracers.has(i) || this._tracers.set(i, new Bc({ name: t, version: r, schemaUrl: n == null ? void 0 : n.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return y.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Vc(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), L.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && N.setGlobalContextManager(t.contextManager), t.propagator && M.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = ne.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== ne.timeout && (o = ne.resolved, i(o));
          }).catch(function(s) {
            clearTimeout(a), o = ne.error, i(s);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(s) {
            return s !== ne.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(ge().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || y.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new ju({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = ge().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || y.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new oc();
      }],
      ["baggage", function() {
        return new pu();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), qc = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, zc = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ki = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = te;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = te);
      var n = this, i = function() {
        for (var o = this, a = [], s = 0; s < arguments.length; s++)
          a[s] = arguments[s];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = te, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = te, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || te;
      try {
        return r.call.apply(r, zc([n], qc(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), Yc = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Wc = (
  /** @class */
  function(e) {
    Yc(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new ki()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(Xc)
), m;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(m || (m = {}));
var Kt;
function Kc() {
  return Kt || (Kt = document.createElement("a")), Kt;
}
function ee(e, t) {
  return t in e;
}
function C(e, t, r, n) {
  var i = void 0, o = void 0;
  ee(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = m.FETCH_START;
  if (ee(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function ye(e, t) {
  C(e, m.FETCH_START, t), C(e, m.DOMAIN_LOOKUP_START, t), C(e, m.DOMAIN_LOOKUP_END, t), C(e, m.CONNECT_START, t), ee(t, "name") && t.name.startsWith("https:") && C(e, m.SECURE_CONNECTION_START, t), C(e, m.CONNECT_END, t), C(e, m.REQUEST_START, t), C(e, m.RESPONSE_START, t), C(e, m.RESPONSE_END, t);
  var r = t[m.ENCODED_BODY_SIZE];
  r !== void 0 && e.setAttribute(ps, r);
  var n = t[m.DECODED_BODY_SIZE];
  n !== void 0 && r !== n && e.setAttribute(_s, n);
}
function Jc(e) {
  return e.slice().sort(function(t, r) {
    var n = t[m.FETCH_START], i = r[m.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function Ui() {
  return typeof location != "undefined" ? location.origin : void 0;
}
function Bi(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = z(e);
  e = a.toString();
  var s = Zc(e, t, r, n, i, o);
  if (s.length === 0)
    return {
      mainRequest: void 0
    };
  if (s.length === 1)
    return {
      mainRequest: s[0]
    };
  var u = Jc(s);
  if (a.origin !== Ui() && u.length > 1) {
    var c = u[0], l = Qc(u, c[m.RESPONSE_END], r), f = c[m.RESPONSE_END], d = l[m.FETCH_START];
    return d < f && (l = c, c = void 0), {
      corsPreFlightRequest: c,
      mainRequest: l
    };
  } else
    return {
      mainRequest: s[0]
    };
}
function Qc(e, t, r) {
  for (var n = Q(r), i = Q(Me(t)), o = e[1], a, s = e.length, u = 1; u < s; u++) {
    var c = e[u], l = Q(Me(c[m.FETCH_START])), f = Q(Me(c[m.RESPONSE_END])), d = n - f;
    l >= i && (!a || d < a) && (a = d, o = c);
  }
  return o;
}
function Zc(e, t, r, n, i, o) {
  var a = Q(t), s = Q(r), u = n.filter(function(c) {
    var l = Q(Me(c[m.FETCH_START])), f = Q(Me(c[m.RESPONSE_END]));
    return c.initiatorType.toLowerCase() === (o || "xmlhttprequest") && c.name === e && l >= a && f <= s;
  });
  return u.length > 0 && (u = u.filter(function(c) {
    return !i.has(c);
  })), u;
}
function z(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document != "undefined" ? document.baseURI : typeof location != "undefined" ? location.href : void 0);
  var t = Kc();
  return t.href = e, t;
}
function Hi(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = tl(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += Hi(e.parentNode, !1)), n += r, n;
}
function el(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function tl(e, t) {
  var r = e.nodeType, n = el(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function Fi(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = z(e);
  return n.origin === Ui() ? !0 : r.some(function(i) {
    return mc(e, i);
  });
}
var ke;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(ke || (ke = {}));
var rl = "0.40.0", nl = "@opentelemetry/instrumentation-document-load", ht;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(ht || (ht = {}));
var il = function() {
  var e, t, r = {}, n = (t = (e = ct).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(m);
    i.forEach(function(s) {
      if (ee(n, s)) {
        var u = n[s];
        typeof u == "number" && (r[s] = u);
      }
    });
  } else {
    var o = ct, a = o.timing;
    if (a) {
      var i = Object.values(m);
      i.forEach(function(u) {
        if (ee(a, u)) {
          var c = a[u];
          typeof c == "number" && (r[u] = c);
        }
      });
    }
  }
  return r;
}, gn = {
  "first-paint": ht.FIRST_PAINT,
  "first-contentful-paint": ht.FIRST_CONTENTFUL_PAINT
}, ol = function(e) {
  var t, r, n = (r = (t = ct).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    ee(gn, o) && e.addEvent(gn[o], a);
  });
}, al = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), sl = (
  /** @class */
  function(e) {
    al(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, nl, rl, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = ct).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(s) {
        n._initResourceSpan(s, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === et;
      }), i = il(), o = n && n.content || "";
      N.with(M.extract(te, { traceparent: o }), function() {
        var a, s = r._startSpan(ke.DOCUMENT_LOAD, m.FETCH_START, i);
        s && (N.with(L.setSpan(N.active(), s), function() {
          var u = r._startSpan(ke.DOCUMENT_FETCH, m.FETCH_START, i);
          u && (u.setAttribute(De, location.href), N.with(L.setSpan(N.active(), u), function() {
            var c;
            r.getConfig().ignoreNetworkEvents || ye(u, i), r._addCustomAttributesOnSpan(u, (c = r.getConfig().applyCustomAttributesOnSpan) === null || c === void 0 ? void 0 : c.documentFetch), r._endSpan(u, m.RESPONSE_END, i);
          }));
        }), s.setAttribute(De, location.href), s.setAttribute(Br, navigator.userAgent), r._addResourcesSpans(s), r.getConfig().ignoreNetworkEvents || (C(s, m.FETCH_START, i), C(s, m.UNLOAD_EVENT_START, i), C(s, m.UNLOAD_EVENT_END, i), C(s, m.DOM_INTERACTIVE, i), C(s, m.DOM_CONTENT_LOADED_EVENT_START, i), C(s, m.DOM_CONTENT_LOADED_EVENT_END, i), C(s, m.DOM_COMPLETE, i), C(s, m.LOAD_EVENT_START, i), C(s, m.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || ol(s), r._addCustomAttributesOnSpan(s, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(s, m.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (ee(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(ke.RESOURCE_FETCH, m.FETCH_START, r, n);
      o && (o.setAttribute(De, r.name), this.getConfig().ignoreNetworkEvents || ye(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, m.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (ee(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? L.setSpan(N.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && lt(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      }, !0);
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && lt(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      }, !0);
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(Ot)
), Jt = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Tr = performance, ul = 9, cl = 6, ll = Math.pow(10, cl), mn = Math.pow(10, ul);
function vr(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * ll);
  return [r, n];
}
function fl() {
  var e = Tr.timeOrigin;
  if (typeof e != "number") {
    var t = Tr;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function yn(e) {
  var t = vr(fl()), r = vr(Tr.now());
  return dl(t, r);
}
function dl(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= mn && (r[1] -= mn, r[0] += 1), r;
}
var pl = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function _l(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function hl(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = pl(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (_l(e, a))
        return !0;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var Et;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(Et || (Et = {}));
var On = "0.53.0", El = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Qt, Tl = 300, Sn = typeof process == "object" && ((Qt = process.release) === null || Qt === void 0 ? void 0 : Qt.name) === "node", vl = (
  /** @class */
  function(e) {
    El(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", On, r) || this;
      return n.component = "fetch", n.version = On, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[m.FETCH_START]
      }, L.setSpan(N.active(), r));
      this.getConfig().ignoreNetworkEvents || ye(i, n), i.end(n[m.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = z(n.url);
      r.setAttribute(fi, n.status), n.statusText != null && r.setAttribute(Et.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(ci, i.host), r.setAttribute(li, i.protocol.replace(":", "")), typeof navigator != "undefined" && r.setAttribute(Br, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!Fi(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        M.inject(N.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        M.inject(N.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (r.headers instanceof Headers)
        M.inject(N.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else if (r.headers instanceof Map)
        M.inject(N.active(), r.headers, {
          set: function(o, a, s) {
            return o.set(a, typeof s == "string" ? s : String(s));
          }
        });
      else {
        var i = {};
        M.inject(N.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), hl(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: He.CLIENT,
        attributes: (i = {}, i[Et.COMPONENT] = this.moduleName, i[ui] = o, i[De] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = Bi(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var s = a.mainRequest;
        this._markResourceAsUsed(s);
        var u = a.corsPreFlightRequest;
        u && (this._addChildSpan(r, u), this._markResourceAsUsed(u)), this.getConfig().ignoreNetworkEvents || ye(r, s);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = vr(Date.now()), s = yn();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var u;
        (u = n.observer) === null || u === void 0 || u.disconnect(), o._findResourceAndAddNetworkEvents(r, n, s), o._tasksCount--, o._clearResources(), r.end(a);
      }, Tl);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var u = this, c = z(a[0] instanceof Request ? a[0].url : String(a[0])).href, l = a[0] instanceof Request ? a[0] : a[1] || {}, f = i._createSpan(c, l);
          if (!f)
            return n.apply(this, a);
          var d = i._prepareSpanData(c);
          function _(T, O) {
            i._applyAttributesAfterFetch(T, l, O), i._endSpan(T, d, {
              status: O.status || 0,
              statusText: O.message,
              url: c
            });
          }
          function E(T, O) {
            i._applyAttributesAfterFetch(T, l, O), O.status >= 200 && O.status < 400 ? i._endSpan(T, d, O) : i._endSpan(T, d, {
              status: O.status,
              statusText: O.statusText,
              url: c
            });
          }
          function p(T, O, b) {
            try {
              var I = b.clone(), H = b.clone(), U = I.body;
              if (U) {
                var bt = U.getReader(), qe = function() {
                  bt.read().then(function(Re) {
                    var To = Re.done;
                    To ? E(T, H) : qe();
                  }, function(Re) {
                    _(T, Re);
                  });
                };
                qe();
              } else
                E(T, b);
            } finally {
              O(b);
            }
          }
          function v(T, O, b) {
            try {
              _(T, b);
            } finally {
              O(b);
            }
          }
          return new Promise(function(T, O) {
            return N.with(L.setSpan(N.active(), f), function() {
              return i._addHeaders(l, c), i._tasksCount++, n.apply(u, l instanceof Request ? [l] : [c, l]).then(p.bind(u, f, T), v.bind(u, f, O));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && lt(function() {
        return a(r, n, i);
      }, function(s) {
        s && o._diag.error("applyCustomAttributesOnSpan", s);
      }, !0);
    }, t.prototype._prepareSpanData = function(r) {
      var n = yn(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var s = a.getEntries();
        s.forEach(function(u) {
          u.initiatorType === "fetch" && u.name === r && i.push(u);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (Sn) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      oe(fetch) && (this._unwrap(Jt, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Jt, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      Sn || (this._unwrap(Jt, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(Ot)
), Fe = performance, gl = 9, ml = 6, yl = Math.pow(10, ml), Rn = Math.pow(10, gl);
function An(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * yl);
  return [r, n];
}
function Ol() {
  var e = Fe.timeOrigin;
  if (typeof e != "number") {
    var t = Fe;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Nn(e) {
  var t = An(Ol()), r = An(Fe.now());
  return Sl(t, r);
}
function Sl(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Rn && (r[1] -= Rn, r[0] += 1), r;
}
var Rl = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Al(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Nl(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = Rl(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (Al(e, a))
        return !0;
    }
  } catch (s) {
    r = { error: s };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var q;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(q || (q = {}));
var Ln = "0.53.0", gr;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(gr || (gr = {}));
var Ll = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), bl = 300, wl = (
  /** @class */
  function(e) {
    Ll(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", Ln, r) || this;
      return n.component = "xml-http-request", n.version = Ln, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = z(n).href;
      if (!Fi(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        M.inject(N.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      M.inject(N.active(), a), Object.keys(a).forEach(function(s) {
        r.setRequestHeader(s, String(a[s]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      N.with(L.setSpan(N.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[m.FETCH_START]
        });
        i.getConfig().ignoreNetworkEvents || ye(o, n), o.end(n[m.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = z(i);
        n.status !== void 0 && r.setAttribute(fi, n.status), n.statusText !== void 0 && r.setAttribute(gr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(ci, o.host), r.setAttribute(li, o.protocol.replace(":", "")), r.setAttribute(Br, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && lt(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      }, !0);
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), s = z(n);
          a.forEach(function(u) {
            u.initiatorType === "xmlhttprequest" && u.name === s.href && i.createdResources && i.createdResources.entries.push(u);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (Fe.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var s = r.createdResources.entries;
        (!s || !s.length) && (s = Fe.getEntriesByType("resource"));
        var u = Bi(z(i).href, o, a, s, this._usedResources);
        if (u.mainRequest) {
          var c = u.mainRequest;
          this._markResourceAsUsed(c);
          var l = u.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), this.getConfig().ignoreNetworkEvents || ye(n, c);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (Nl(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), s = this.tracer.startSpan(a, {
        kind: He.CLIENT,
        attributes: (o = {}, o[ui] = i, o[De] = z(n).toString(), o)
      });
      return s.addEvent(q.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: s,
        spanUrl: n
      }), s;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var a = [], s = 0; s < arguments.length; s++)
            a[s] = arguments[s];
          var u = a[0], c = a[1];
          return i._createSpan(this, c, u), n.apply(this, a);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, f, d, _) {
        var E = f.callbackToRemoveEvents;
        typeof E == "function" && E();
        var p = f.span, v = f.spanUrl, T = f.sendStartTime;
        p && (r._findResourceAndAddNetworkEvents(f, p, v, T, d), p.addEvent(l, _), r._addFinalSpanAttributes(p, f, v), p.end(_), r._tasksCount--), r._clearResources();
      }
      function i(l, f) {
        var d = r._xhrMem.get(f);
        if (d) {
          d.status = f.status, d.statusText = f.statusText, r._xhrMem.delete(f), d.span && r._applyAttributesAfterXHR(d.span, f);
          var _ = Nn(), E = Date.now();
          setTimeout(function() {
            n(l, d, _, E);
          }, bl);
        }
      }
      function o() {
        i(q.EVENT_ERROR, this);
      }
      function a() {
        i(q.EVENT_ABORT, this);
      }
      function s() {
        i(q.EVENT_TIMEOUT, this);
      }
      function u() {
        this.status < 299 ? i(q.EVENT_LOAD, this) : i(q.EVENT_ERROR, this);
      }
      function c(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", u), l.removeEventListener("timeout", s);
        var f = r._xhrMem.get(l);
        f && (f.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var d = this, _ = [], E = 0; E < arguments.length; E++)
            _[E] = arguments[E];
          var p = r._xhrMem.get(this);
          if (!p)
            return l.apply(this, _);
          var v = p.span, T = p.spanUrl;
          return v && T && N.with(L.setSpan(N.active(), v), function() {
            r._tasksCount++, p.sendStartTime = Nn(), v.addEvent(q.METHOD_SEND), d.addEventListener("abort", a), d.addEventListener("error", o), d.addEventListener("load", u), d.addEventListener("timeout", s), p.callbackToRemoveEvents = function() {
              c(d), p.createdResources && p.createdResources.observer.disconnect();
            }, r._addHeaders(d, T), r._addResourceObserver(d, T);
          }), l.apply(this, _);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), oe(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), oe(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(Ot)
);
function Il() {
  return "unknown_service";
}
var W = function() {
  return W = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, W.apply(this, arguments);
}, Pl = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, Cl = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, xl = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Dl = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r == null ? void 0 : r.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return y.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[pi] = Il(), t[Te] = jt[Te], t[Ee] = jt[Ee], t[ve] = jt[ve], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && y.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Pl(this, void 0, void 0, function() {
        return Cl(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = W(W({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var s, u = xl(a, 2), c = u[0], l = u[1];
        return W(W(W(W({}, r._syncAttributes), c), (s = t._syncAttributes) !== null && s !== void 0 ? s : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
);
function Zt(e, t) {
  if (!!!e)
    throw new Error(t);
}
function Ml(e) {
  return typeof e == "object" && e !== null;
}
function kl(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const Ul = /\r\n|[\n\r]/g;
function mr(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(Ul)) {
    if (typeof i.index == "number" || kl(!1), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function Bl(e) {
  return Gi(
    e.source,
    mr(e.source, e.start)
  );
}
function Gi(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, o = e.locationOffset.line - 1, a = t.line + o, s = t.line === 1 ? r : 0, u = t.column + s, c = `${e.name}:${a}:${u}
`, l = n.split(/\r\n|[\n\r]/g), f = l[i];
  if (f.length > 120) {
    const d = Math.floor(u / 80), _ = u % 80, E = [];
    for (let p = 0; p < f.length; p += 80)
      E.push(f.slice(p, p + 80));
    return c + bn([
      [`${a} |`, E[0]],
      ...E.slice(1, d + 1).map((p) => ["|", p]),
      ["|", "^".padStart(_)],
      ["|", E[d + 1]]
    ]);
  }
  return c + bn([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, l[i - 1]],
    [`${a} |`, f],
    ["|", "^".padStart(u)],
    [`${a + 1} |`, l[i + 1]]
  ]);
}
function bn(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function Hl(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class jr extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, o;
    const { nodes: a, source: s, positions: u, path: c, originalError: l, extensions: f } = Hl(r);
    super(t), this.name = "GraphQLError", this.path = c != null ? c : void 0, this.originalError = l != null ? l : void 0, this.nodes = wn(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const d = wn(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((E) => E.loc).filter((E) => E != null)
    );
    this.source = s != null ? s : d == null || (i = d[0]) === null || i === void 0 ? void 0 : i.source, this.positions = u != null ? u : d == null ? void 0 : d.map((E) => E.start), this.locations = u && s ? u.map((E) => mr(s, E)) : d == null ? void 0 : d.map((E) => mr(E.source, E.start));
    const _ = Ml(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (o = f != null ? f : _) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, jr) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + Bl(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + Gi(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function wn(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function x(e, t, r) {
  return new jr(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
class Fl {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class ji {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, o, a) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Gl = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, jl = new Set(Object.keys(Gl));
function bp(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && jl.has(t);
}
var de;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(de || (de = {}));
var yr;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(yr || (yr = {}));
var g;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(g || (g = {}));
function Or(e) {
  return e === 9 || e === 32;
}
function Ge(e) {
  return e >= 48 && e <= 57;
}
function Vi(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function $i(e) {
  return Vi(e) || e === 95;
}
function Vl(e) {
  return Vi(e) || Ge(e) || e === 95;
}
function $l(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let a = 0; a < e.length; ++a) {
    var o;
    const s = e[a], u = Xl(s);
    u !== s.length && (n = (o = n) !== null && o !== void 0 ? o : a, i = a, a !== 0 && u < r && (r = u));
  }
  return e.map((a, s) => s === 0 ? a : a.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function Xl(e) {
  let t = 0;
  for (; t < e.length && Or(e.charCodeAt(t)); )
    ++t;
  return t;
}
function wp(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, o = n.length > 1 && n.slice(1).every((_) => _.length === 0 || Or(_.charCodeAt(0))), a = r.endsWith('\\"""'), s = e.endsWith('"') && !a, u = e.endsWith("\\"), c = s || u, l = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || c || o || a
  );
  let f = "";
  const d = i && Or(e.charCodeAt(0));
  return (l && !d || o) && (f += `
`), f += r, (l || c) && (f += `
`), '"""' + f + '"""';
}
var h;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(h || (h = {}));
class ql {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new ji(h.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== h.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = Yl(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === h.COMMENT);
    return t;
  }
}
function zl(e) {
  return e === h.BANG || e === h.DOLLAR || e === h.AMP || e === h.PAREN_L || e === h.PAREN_R || e === h.SPREAD || e === h.COLON || e === h.EQUALS || e === h.AT || e === h.BRACKET_L || e === h.BRACKET_R || e === h.BRACE_L || e === h.PIPE || e === h.BRACE_R;
}
function Se(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function St(e, t) {
  return Xi(e.charCodeAt(t)) && qi(e.charCodeAt(t + 1));
}
function Xi(e) {
  return e >= 55296 && e <= 56319;
}
function qi(e) {
  return e >= 56320 && e <= 57343;
}
function se(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return h.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function P(e, t, r, n, i) {
  const o = e.line, a = 1 + r - e.lineStart;
  return new ji(t, r, n, o, a, i);
}
function Yl(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return Wl(e, i);
      case 33:
        return P(e, h.BANG, i, i + 1);
      case 36:
        return P(e, h.DOLLAR, i, i + 1);
      case 38:
        return P(e, h.AMP, i, i + 1);
      case 40:
        return P(e, h.PAREN_L, i, i + 1);
      case 41:
        return P(e, h.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return P(e, h.SPREAD, i, i + 3);
        break;
      case 58:
        return P(e, h.COLON, i, i + 1);
      case 61:
        return P(e, h.EQUALS, i, i + 1);
      case 64:
        return P(e, h.AT, i, i + 1);
      case 91:
        return P(e, h.BRACKET_L, i, i + 1);
      case 93:
        return P(e, h.BRACKET_R, i, i + 1);
      case 123:
        return P(e, h.BRACE_L, i, i + 1);
      case 124:
        return P(e, h.PIPE, i, i + 1);
      case 125:
        return P(e, h.BRACE_R, i, i + 1);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? tf(e, i) : Jl(e, i);
    }
    if (Ge(o) || o === 45)
      return Kl(e, i, o);
    if ($i(o))
      return rf(e, i);
    throw x(
      e.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Se(o) || St(r, i) ? `Unexpected character: ${se(e, i)}.` : `Invalid character: ${se(e, i)}.`
    );
  }
  return P(e, h.EOF, n, n);
}
function Wl(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (Se(o))
      ++i;
    else if (St(r, i))
      i += 2;
    else
      break;
  }
  return P(
    e,
    h.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function Kl(e, t, r) {
  const n = e.source.body;
  let i = t, o = r, a = !1;
  if (o === 45 && (o = n.charCodeAt(++i)), o === 48) {
    if (o = n.charCodeAt(++i), Ge(o))
      throw x(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${se(
          e,
          i
        )}.`
      );
  } else
    i = er(e, i, o), o = n.charCodeAt(i);
  if (o === 46 && (a = !0, o = n.charCodeAt(++i), i = er(e, i, o), o = n.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = n.charCodeAt(++i), (o === 43 || o === 45) && (o = n.charCodeAt(++i)), i = er(e, i, o), o = n.charCodeAt(i)), o === 46 || $i(o))
    throw x(
      e.source,
      i,
      `Invalid number, expected digit but got: ${se(
        e,
        i
      )}.`
    );
  return P(
    e,
    a ? h.FLOAT : h.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function er(e, t, r) {
  if (!Ge(r))
    throw x(
      e.source,
      t,
      `Invalid number, expected digit but got: ${se(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; Ge(n.charCodeAt(i)); )
    ++i;
  return i;
}
function Jl(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, o = i, a = "";
  for (; i < n; ) {
    const s = r.charCodeAt(i);
    if (s === 34)
      return a += r.slice(o, i), P(e, h.STRING, t, i + 1, a);
    if (s === 92) {
      a += r.slice(o, i);
      const u = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? Ql(e, i) : Zl(e, i) : ef(e, i);
      a += u.value, i += u.size, o = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Se(s))
      ++i;
    else if (St(r, i))
      i += 2;
    else
      throw x(
        e.source,
        i,
        `Invalid character within String: ${se(
          e,
          i
        )}.`
      );
  }
  throw x(e.source, i, "Unterminated string.");
}
function Ql(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const o = r.charCodeAt(t + i++);
    if (o === 125) {
      if (i < 5 || !Se(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | Ie(o), n < 0)
      break;
  }
  throw x(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function Zl(e, t) {
  const r = e.source.body, n = In(r, t + 2);
  if (Se(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (Xi(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = In(r, t + 8);
    if (qi(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw x(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function In(e, t) {
  return Ie(e.charCodeAt(t)) << 12 | Ie(e.charCodeAt(t + 1)) << 8 | Ie(e.charCodeAt(t + 2)) << 4 | Ie(e.charCodeAt(t + 3));
}
function Ie(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function ef(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw x(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function tf(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, o = t + 3, a = o, s = "";
  const u = [];
  for (; o < n; ) {
    const c = r.charCodeAt(o);
    if (c === 34 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34) {
      s += r.slice(a, o), u.push(s);
      const l = P(
        e,
        h.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        $l(u).join(`
`)
      );
      return e.line += u.length - 1, e.lineStart = i, l;
    }
    if (c === 92 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34 && r.charCodeAt(o + 3) === 34) {
      s += r.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (c === 10 || c === 13) {
      s += r.slice(a, o), u.push(s), c === 13 && r.charCodeAt(o + 1) === 10 ? o += 2 : ++o, s = "", a = o, i = o;
      continue;
    }
    if (Se(c))
      ++o;
    else if (St(r, o))
      o += 2;
    else
      throw x(
        e.source,
        o,
        `Invalid character within String: ${se(
          e,
          o
        )}.`
      );
  }
  throw x(e.source, o, "Unterminated string.");
}
function rf(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (Vl(o))
      ++i;
    else
      break;
  }
  return P(
    e,
    h.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const nf = 10, zi = 2;
function Yi(e) {
  return Rt(e, []);
}
function Rt(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return of(e, t);
    default:
      return String(e);
  }
}
function of(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (af(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Rt(n, r);
  } else if (Array.isArray(e))
    return uf(e, r);
  return sf(e, r);
}
function af(e) {
  return typeof e.toJSON == "function";
}
function sf(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > zi ? "[" + cf(e) + "]" : "{ " + r.map(
    ([i, o]) => i + ": " + Rt(o, t)
  ).join(", ") + " }";
}
function uf(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > zi)
    return "[Array]";
  const r = Math.min(nf, e.length), n = e.length - r, i = [];
  for (let o = 0; o < r; ++o)
    i.push(Rt(e[o], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function cf(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const lf = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(t, r) {
    return t instanceof r;
  } : function(t, r) {
    if (t instanceof r)
      return !0;
    if (typeof t == "object" && t !== null) {
      var n;
      const i = r.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
      );
      if (i === o) {
        const a = Yi(t);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class Wi {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || Zt(!1, `Body must be a string. Received: ${Yi(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || Zt(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Zt(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function ff(e) {
  return lf(e, Wi);
}
function df(e, t) {
  return new pf(e, t).parseDocument();
}
class pf {
  constructor(t, r = {}) {
    const n = ff(t) ? t : new Wi(t);
    this._lexer = new ql(n), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(h.NAME);
    return this.node(t, {
      kind: g.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: g.DOCUMENT,
      definitions: this.many(
        h.SOF,
        this.parseDefinition,
        h.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(h.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === h.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw x(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(h.BRACE_L))
      return this.node(t, {
        kind: g.OPERATION_DEFINITION,
        operation: de.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let n;
    return this.peek(h.NAME) && (n = this.parseName()), this.node(t, {
      kind: g.OPERATION_DEFINITION,
      operation: r,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(h.NAME);
    switch (t.value) {
      case "query":
        return de.QUERY;
      case "mutation":
        return de.MUTATION;
      case "subscription":
        return de.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      h.PAREN_L,
      this.parseVariableDefinition,
      h.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: g.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(h.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(h.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(h.DOLLAR), this.node(t, {
      kind: g.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: g.SELECTION_SET,
      selections: this.many(
        h.BRACE_L,
        this.parseSelection,
        h.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(h.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(h.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: g.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(h.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(h.PAREN_L, r, h.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(h.COLON), this.node(r, {
      kind: g.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(h.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(h.NAME) ? this.node(t, {
      kind: g.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: g.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: g.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: g.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case h.BRACKET_L:
        return this.parseList(t);
      case h.BRACE_L:
        return this.parseObject(t);
      case h.INT:
        return this.advanceLexer(), this.node(r, {
          kind: g.INT,
          value: r.value
        });
      case h.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: g.FLOAT,
          value: r.value
        });
      case h.STRING:
      case h.BLOCK_STRING:
        return this.parseStringLiteral();
      case h.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: g.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: g.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: g.NULL
            });
          default:
            return this.node(r, {
              kind: g.ENUM,
              value: r.value
            });
        }
      case h.DOLLAR:
        if (t)
          if (this.expectToken(h.DOLLAR), this._lexer.token.kind === h.NAME) {
            const n = this._lexer.token.value;
            throw x(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: g.STRING,
      value: t.value,
      block: t.kind === h.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: g.LIST,
      values: this.any(h.BRACKET_L, r, h.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: g.OBJECT,
      fields: this.any(h.BRACE_L, r, h.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(h.COLON), this.node(r, {
      kind: g.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(h.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(h.AT), this.node(r, {
      kind: g.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(h.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(h.BRACKET_R), r = this.node(t, {
        kind: g.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(h.BANG) ? this.node(t, {
      kind: g.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: g.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(h.STRING) || this.peek(h.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      h.BRACE_L,
      this.parseOperationTypeDefinition,
      h.BRACE_R
    );
    return this.node(t, {
      kind: g.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(h.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: g.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: g.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: g.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(h.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      h.BRACE_L,
      this.parseFieldDefinition,
      h.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(h.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(t, {
      kind: g.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      h.PAREN_L,
      this.parseInputValueDef,
      h.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(h.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(h.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(t, {
      kind: g.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: g.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: g.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(h.EQUALS) ? this.delimitedMany(h.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: g.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      h.BRACE_L,
      this.parseEnumValueDefinition,
      h.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: g.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw x(
        this._lexer.source,
        this._lexer.token.start,
        `${Qe(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: g.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      h.BRACE_L,
      this.parseInputValueDef,
      h.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === h.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      h.BRACE_L,
      this.parseOperationTypeDefinition,
      h.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: g.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(h.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(t, {
      kind: g.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(h.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(yr, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new Fl(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw x(
      this._lexer.source,
      r.start,
      `Expected ${Ki(t)}, found ${Qe(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === h.NAME && r.value === t)
      this.advanceLexer();
    else
      throw x(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Qe(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === h.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t != null ? t : this._lexer.token;
    return x(
      this._lexer.source,
      r.start,
      `Unexpected ${Qe(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (t !== void 0 && r.kind !== h.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw x(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function Qe(e) {
  const t = e.value;
  return Ki(e.kind) + (t != null ? ` "${t}"` : "");
}
function Ki(e) {
  return zl(e) ? `"${e}"` : e;
}
/*! js-cookie v3.0.5 | MIT */
function Ze(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var _f = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Sr(e, t) {
  function r(i, o, a) {
    if (typeof document != "undefined") {
      a = Ze({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var u in a)
        a[u] && (s += "; " + u, a[u] !== !0 && (s += "=" + a[u].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + s;
    }
  }
  function n(i) {
    if (!(typeof document == "undefined" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, s = 0; s < o.length; s++) {
        var u = o[s].split("="), c = u.slice(1).join("=");
        try {
          var l = decodeURIComponent(u[0]);
          if (a[l] = e.read(c, l), i === l)
            break;
        } catch (f) {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(i, o) {
        r(
          i,
          "",
          Ze({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return Sr(this.converter, Ze({}, this.attributes, i));
      },
      withConverter: function(i) {
        return Sr(Ze({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var tr = Sr(_f, { path: "/" });
let Vr = "localStorage", Rr = !0;
class hf {
  constructor() {
    S(this, "storage", {});
  }
  getItem(t) {
    var r;
    return (r = this.storage[t]) != null ? r : "";
  }
  setItem(t, r) {
    this.storage[t] = r;
  }
  removeItem(t) {
    delete this.storage[t];
  }
}
class Ef {
  getItem(t) {
    var r;
    return (r = tr.get(t)) != null ? r : "";
  }
  setItem(t, r) {
    if (!Rr)
      return;
    const n = /* @__PURE__ */ new Date();
    n.setTime(n.getTime() + 9e5), tr.set(t, r, { expires: n });
  }
  removeItem(t) {
    Rr && tr.remove(t);
  }
}
let Tf = new hf();
const Tt = new Ef(), $r = () => {
  try {
    switch (Vr) {
      case "localStorage":
        return window.localStorage;
      case "sessionStorage":
        return window.sessionStorage;
    }
  } catch (e) {
    return Tf;
  }
}, Ip = (e) => {
  Vr = e;
}, vf = (e) => {
  Rr = e;
}, Ji = (e) => $r().getItem(e), Qi = (e, t) => (Tt.setItem(e, t), $r().setItem(e, t)), gf = (e) => (Tt.removeItem(e), $r().removeItem(e)), Pp = (e) => {
  if (Vr === "sessionStorage") {
    console.warn("highlight.io cannot use local storage; segment integration will not work");
    return;
  }
  const t = window.localStorage.setItem;
  window.localStorage.setItem = function() {
    const [r, n] = arguments;
    e({ keyName: r, keyValue: n }), t.apply(this, [r, n]);
  };
};
var Oe;
(function(e) {
  e.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", e.SESSION_ID = "sessionID", e.SESSION_DATA = "sessionData", e.USER_IDENTIFIER = "highlightIdentifier", e.USER_OBJECT = "highlightUserObject";
})(Oe || (Oe = {}));
const At = (e) => `${Oe.SESSION_DATA}_${e}`;
let Zi = "";
const mf = () => Zi, yf = (e) => {
  e && (Zi = e);
}, Of = () => {
  var e;
  return (e = Ji(Oe.SESSION_ID)) != null ? e : "";
}, Sf = (e) => {
  Qi(Oe.SESSION_ID, e);
}, Rf = (e) => {
  const t = At(e);
  return JSON.parse(Ji(t) || "{}");
}, rr = (e) => {
  e || (e = Of());
  let t = Rf(e);
  if (t && t.lastPushTime && Date.now() - t.lastPushTime < 9e5)
    return t;
  gf(At(e));
}, Af = function(e) {
  if (!(e != null && e.sessionSecureID))
    return;
  const t = e.sessionSecureID;
  yf(t), Qi(At(t), JSON.stringify(e));
}, Nf = function() {
  const e = Tt.getItem(Oe.SESSION_ID);
  Sf(e);
  const t = At(e), r = Tt.getItem(t);
  try {
    Af(JSON.parse(r));
  } catch (n) {
  }
}, Pn = (e, t, r) => {
  const n = eo(t, e.headers, r);
  return B(D({}, e), {
    headers: n
  });
}, eo = (e, t, r) => {
  var i, o;
  const n = D({}, t);
  return r ? ((i = Object.keys(n)) == null || i.forEach((a) => {
    [...r].includes(a == null ? void 0 : a.toLowerCase()) || (n[a] = "[REDACTED]");
  }), n) : ((o = Object.keys(n)) == null || o.forEach((a) => {
    [...Lf, ...e].includes(a == null ? void 0 : a.toLowerCase()) && (n[a] = "[REDACTED]");
  }), n);
}, Lf = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], to = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], ro = "X-Highlight-Request", Cn = (e) => {
  let t = e;
  return !e.startsWith("https://") && !e.startsWith("http://") && (t = `${window.location.origin}${t}`), t.replace(/\/+$/, "");
}, bf = (e, { headersToRedact: t, headersToRecord: r, requestResponseSanitizer: n }) => {
  var u, c;
  let i = e;
  if (n) {
    let f = !0;
    try {
      i.request.body = JSON.parse(i.request.body);
    } catch (_) {
      f = !1;
    }
    let d = !0;
    try {
      i.response.body = JSON.parse(i.response.body);
    } catch (_) {
      d = !1;
    }
    try {
      i = n(i);
    } catch (_) {
    } finally {
      f = f && !!((u = i == null ? void 0 : i.request) != null && u.body), d = d && !!((c = i == null ? void 0 : i.response) != null && c.body), f && (i.request.body = JSON.stringify(i.request.body)), d && (i.response.body = JSON.stringify(i.response.body));
    }
    if (!i)
      return null;
  }
  const l = i, { request: o, response: a } = l, s = It(l, ["request", "response"]);
  return D({
    request: Pn(o, t, r),
    response: Pn(a, t, r)
  }, s);
}, xn = (e, t, r, n) => {
  e.sort((u, c) => u.responseEnd - c.responseEnd);
  const i = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  }, o = e.reduce((u, c) => {
    const l = Cn(c.name);
    return c.initiatorType === r ? u[r][l] = [
      ...u[r][l] || [],
      c
    ] : u.others[l] = [
      ...u.others[l] || [],
      c
    ], u;
  }, i);
  let a = {};
  a = t.reduce((u, c) => {
    const l = Cn(c.request.url);
    return u[l] = [...u[l] || [], c], u;
  }, a);
  for (let u in o[r]) {
    const c = o[r][u], l = a[u];
    if (!l)
      continue;
    const f = Math.max(c.length - l.length, 0);
    for (let d = f; d < c.length; d++)
      c[d] && (c[d].requestResponsePair = l[d - f]);
  }
  let s = [];
  for (let u in o)
    for (let c in o[u])
      s = s.concat(o[u][c]);
  return s.sort((u, c) => u.fetchStart - c.fetchStart).reduce((u, c) => {
    let l = c.requestResponsePair;
    return l && (l = bf(c.requestResponsePair, n), !l) || (c.toJSON = function() {
      const f = window.performance.timeOrigin;
      return {
        initiatorType: this.initiatorType,
        startTimeAbs: f + this.startTime,
        connectStartAbs: f + this.connectStart,
        connectEndAbs: f + this.connectEnd,
        domainLookupStartAbs: f + this.domainLookupStart,
        domainLookupEndAbs: f + this.domainLookupEnd,
        fetchStartAbs: f + this.fetchStart,
        redirectStartAbs: f + this.redirectStart,
        redirectEndAbs: f + this.redirectEnd,
        requestStartAbs: f + this.requestStart,
        responseStartAbs: f + this.responseStart,
        responseEndAbs: f + this.responseEnd,
        secureConnectionStartAbs: f + this.secureConnectionStart,
        workerStartAbs: f + this.workerStart,
        name: this.name,
        transferSize: this.transferSize,
        encodedBodySize: this.encodedBodySize,
        decodedBodySize: this.decodedBodySize,
        nextHopProtocol: this.nextHopProtocol,
        requestResponsePairs: l
      };
    }, u.push(c)), u;
  }, []);
}, wf = (e, t) => e.toLocaleLowerCase().includes("pub.highlight.io") || e.toLocaleLowerCase().includes("pub.highlight.io") || e.toLocaleLowerCase().includes("otel.highlight.io") || t.some((r) => e.toLocaleLowerCase().includes(r)), Nt = (e, t, r) => !wf(e, t) || Xr(e, r != null ? r : [], []), Xr = (e, t, r) => {
  var o;
  if (r.some((a) => e.toLowerCase().includes(a)))
    return !1;
  let n = [];
  t === !0 ? (n = ["localhost", /^\//], (o = window == null ? void 0 : window.location) != null && o.host && n.push(window.location.host)) : t instanceof Array && (n = t);
  let i = !1;
  return n.forEach((a) => {
    e.match(a) && (i = !0);
  }), i;
};
function If(e) {
  for (var t = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = r.length, i = 0; i < e; i++)
    t += r.charAt(Math.floor(Math.random() * n));
  return t;
}
const qr = () => {
  const e = If(10), t = cp(), r = t == null ? void 0 : t.spanContext().traceId;
  return [mf(), r != null ? r : e];
}, no = (e, t) => e + "/" + t, Pf = (e, t, r, n, i, o) => {
  const a = XMLHttpRequest.prototype, s = a.open, u = a.send, c = a.setRequestHeader;
  return a.open = function(l, f) {
    return typeof f == "string" ? this._url = f : this._url = f.toString(), this._method = l, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !n.some((d) => this._url.toLowerCase().includes(d)), s.apply(this, arguments);
  }, a.setRequestHeader = function(l, f) {
    return this._requestHeaders[l] = f, c.apply(this, arguments);
  }, a.send = function(l) {
    if (!Nt(this._url, t, r))
      return u.apply(this, arguments);
    const [f, d] = qr();
    Xr(this._url, r, n) && this.setRequestHeader(ro, no(f, d));
    const _ = this._shouldRecordHeaderAndBody, E = {
      sessionSecureID: f,
      id: d,
      url: this._url,
      verb: this._method,
      headers: _ ? this._requestHeaders : {},
      body: void 0
    };
    if (_ && l) {
      const p = Dn(l, E.url);
      p && (this._body = p, E.body = K(p, i, o, E.headers));
    }
    return this.addEventListener("load", function() {
      return F(this, null, function* () {
        const p = {
          status: this.status,
          headers: {},
          body: void 0
        };
        if (_) {
          const O = this.getAllResponseHeaders().trim().split(/[\r\n]+/), b = {};
          if (O.forEach(function(I) {
            const H = I.split(": "), U = H.shift();
            b[U] = H.join(": ");
          }), p.headers = b, l) {
            const I = Dn(l, E.url);
            I && (E.body = K(I, i, o, p.headers));
          }
          if (this.responseType === "" || this.responseType === "text")
            p.body = K(this.responseText, i, o, p.headers), p.size = this.responseText.length * 8;
          else if (this.responseType === "blob") {
            if (this.response instanceof Blob)
              try {
                const I = yield this.response.text();
                p.body = K(I, i, o, p.headers), p.size = this.response.size;
              } catch (I) {
              }
          } else
            try {
              p.body = K(this.response, i, o, p.headers);
            } catch (I) {
            }
        }
        e({
          request: E,
          response: p,
          urlBlocked: !_
        });
      });
    }), this.addEventListener("error", function() {
      return F(this, null, function* () {
        const p = {
          status: this.status,
          headers: void 0,
          body: void 0
        };
        e({
          request: E,
          response: p,
          urlBlocked: !1
        });
      });
    }), u.apply(this, arguments);
  }, () => {
    a.open = s, a.send = u, a.setRequestHeader = c;
  };
}, Dn = (e, t) => {
  if (typeof e == "string") {
    if (!((t != null && t.includes("localhost") || t != null && t.includes("highlight.run")) && e.includes("pushPayload")))
      return e;
  } else if (typeof e == "object" || typeof e == "number" || typeof e == "boolean")
    return st(e);
  return null;
}, Mn = 64 * 1024, Cf = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, K = (e, t, r, n) => {
  var o, a, s;
  let i = Mn;
  if (n) {
    let u = "";
    typeof n.get == "function" ? u = (o = n.get("content-type")) != null ? o : "" : u = (a = n["content-type"]) != null ? a : "";
    try {
      u = u.split(";")[0];
    } catch (c) {
    }
    i = (s = Cf[u]) != null ? s : Mn;
  }
  if (e) {
    if (t)
      try {
        const u = JSON.parse(e);
        Array.isArray(u) ? u.forEach((c) => {
          Object.keys(c).forEach((l) => {
            t.includes(l.toLocaleLowerCase()) && (c[l] = "[REDACTED]");
          });
        }) : Object.keys(u).forEach((c) => {
          t.includes(c.toLocaleLowerCase()) && (u[c] = "[REDACTED]");
        }), e = JSON.stringify(u);
      } catch (u) {
      }
    if (r)
      try {
        const u = JSON.parse(e);
        Object.keys(u).forEach((c) => {
          r.includes(c.toLocaleLowerCase()) || (u[c] = "[REDACTED]");
        }), e = JSON.stringify(u);
      } catch (u) {
      }
  }
  try {
    e = e.slice(0, i);
  } catch (u) {
  }
  return e;
}, xf = (e, t, r, n, i, o) => {
  const a = window._fetchProxy;
  return window._fetchProxy = function(s, u) {
    const { method: c, url: l } = Df(s, u);
    if (!Nt(l, t, r))
      return a.call(this, s, u);
    const [f, d] = qr();
    if (Xr(l, r, n)) {
      u = u || {};
      let v = new Headers(u.headers);
      s instanceof Request && [...s.headers].forEach(([T, O]) => v.set(T, O)), v.set(ro, no(f, d)), u.headers = Object.fromEntries(v.entries());
    }
    const _ = {
      sessionSecureID: f,
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: c
    }, E = !n.some((v) => l.toLowerCase().includes(v));
    E && (_.headers = Object.fromEntries(new Headers(u == null ? void 0 : u.headers).entries()), _.body = K(u == null ? void 0 : u.body, i, o, u == null ? void 0 : u.headers));
    let p = a.call(this, s, u);
    return Mf(p, _, e, E, i, o), p;
  }, () => {
    window._fetchProxy = a;
  };
}, Df = (e, t) => {
  const r = t && t.method || typeof e == "object" && "method" in e && e.method || "GET";
  let n;
  return typeof e == "object" ? "url" in e && e.url ? n = e.url : n = e.toString() : n = e, {
    method: r,
    url: n
  };
}, Mf = (e, t, r, n, i, o) => {
  const a = (s) => F(void 0, null, function* () {
    let u = {
      body: void 0,
      headers: void 0,
      status: 0,
      size: 0
    }, c = !1, l = !n;
    "stack" in s || s instanceof Error ? (u = B(D({}, u), {
      body: s.message,
      status: 0,
      size: void 0
    }), c = !0) : "status" in s && (u = B(D({}, u), {
      status: s.status
    }), n && (u.body = yield io(s, o, i), u.headers = Object.fromEntries(s.headers.entries()), u.size = u.body.length * 8), (s.type === "opaque" || s.type === "opaqueredirect") && (l = !0, u = B(D({}, u), {
      body: "CORS blocked request"
    })), c = !0), c && r({
      request: t,
      response: u,
      urlBlocked: l
    });
  });
  e.then(a).catch(() => {
  });
}, io = (e, t, r) => F(void 0, null, function* () {
  let n;
  try {
    const o = e.clone().body;
    if (o) {
      let a = o.getReader(), s = new TextDecoder(), u, c = "";
      for (; !(u = yield a.read()).done; ) {
        let l = u.value;
        c += s.decode(l);
      }
      n = c, n = K(n, r, t, e.headers);
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var kf = "=", Ar = ";", oo = ",", Uf = 8192, Bf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Hf(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? oo : "") + r;
    return n.length > Uf ? t : n;
  }, "");
}
function Ff(e) {
  return e.getAllEntries().map(function(t) {
    var r = Bf(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += Ar + i.metadata.toString()), o;
  });
}
function ao(e) {
  var t = e.split(Ar);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(kf);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Cr(t.join(Ar))), { key: i, value: o, metadata: a };
      }
    }
  }
}
function Gf(e) {
  return typeof e != "string" || e.length === 0 ? {} : e.split(oo).map(function(t) {
    return ao(t);
  }).filter(function(t) {
    return t !== void 0 && t.value.length > 0;
  }).reduce(function(t, r) {
    return t[r.key] = r.value, t;
  }, {});
}
var Nr;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(Nr || (Nr = {}));
var jf = ",", Vf = ["OTEL_SDK_DISABLED"];
function $f(e) {
  return Vf.indexOf(e) > -1;
}
var Xf = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function qf(e) {
  return Xf.indexOf(e) > -1;
}
var zf = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS"
];
function Yf(e) {
  return zf.indexOf(e) > -1;
}
var nr = 1 / 0, ir = 128, Wf = 128, Kf = 128, so = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: A.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: nr,
  OTEL_ATTRIBUTE_COUNT_LIMIT: ir,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: nr,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: ir,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: nr,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: ir,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Wf,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Kf,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: Nr.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
function Jf(e, t, r) {
  if (typeof r[e] != "undefined") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function Qf(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] != "undefined") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function Zf(e, t, r, n) {
  n === void 0 && (n = jf);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var ed = {
  ALL: A.ALL,
  VERBOSE: A.VERBOSE,
  DEBUG: A.DEBUG,
  INFO: A.INFO,
  WARN: A.WARN,
  ERROR: A.ERROR,
  NONE: A.NONE
};
function td(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = ed[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function rd(e) {
  var t = {};
  for (var r in so) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        td(n, t, e);
        break;
      default:
        if ($f(n))
          Jf(n, t, e);
        else if (qf(n))
          Qf(n, t, e);
        else if (Yf(n))
          Zf(n, t, e);
        else {
          var i = e[n];
          typeof i != "undefined" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var nd = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Lr() {
  var e = rd(nd);
  return Object.assign({}, so, e);
}
var pe;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(pe || (pe = {}));
var id = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), od = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ad = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, sd = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new id();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, ad([this._that], od(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), ud = {
  getKeyPairs: Ff,
  serializeKeyPairs: Hf,
  parseKeyPairsIntoRecord: Gf,
  parsePairKeyValue: ao
}, cd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, uo = 1e4;
function ld(e) {
  e === void 0 && (e = {});
  var t = {};
  return Object.entries(e).forEach(function(r) {
    var n = cd(r, 2), i = n[0], o = n[1];
    typeof o != "undefined" ? t[i] = String(o) : y.warn('Header "' + i + '" has invalid value (' + o + ") and will be ignored");
  }), t;
}
function fd(e) {
  return typeof e == "number" ? e <= 0 ? co(e, uo) : e : dd();
}
function dd() {
  var e, t = Number((e = Lr().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) !== null && e !== void 0 ? e : Lr().OTEL_EXPORTER_OTLP_TIMEOUT);
  return t <= 0 ? co(t, uo) : t;
}
function co(e, t) {
  return y.warn("Timeout must be greater than 0", e), t;
}
function pd(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function _d(e) {
  if (e == null)
    return -1;
  var t = Number.parseInt(e, 10);
  if (Number.isInteger(t))
    return t > 0 ? t * 1e3 : -1;
  var r = new Date(e).getTime() - Date.now();
  return r >= 0 ? r : 0;
}
var hd = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {}), this._sendingPromises = [], this.url = this.getDefaultUrl(t), typeof t.hostname == "string" && (this.hostname = t.hostname), this.shutdown = this.shutdown.bind(this), this._shutdownOnce = new sd(this._shutdown, this), this._concurrencyLimit = typeof t.concurrencyLimit == "number" ? t.concurrencyLimit : 30, this.timeoutMillis = fd(t.timeoutMillis), this.onInit(t);
    }
    return e.prototype.export = function(t, r) {
      if (this._shutdownOnce.isCalled) {
        r({
          code: pe.FAILED,
          error: new Error("Exporter has been shutdown")
        });
        return;
      }
      if (this._sendingPromises.length >= this._concurrencyLimit) {
        r({
          code: pe.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      this._export(t).then(function() {
        r({ code: pe.SUCCESS });
      }).catch(function(n) {
        r({ code: pe.FAILED, error: n });
      });
    }, e.prototype._export = function(t) {
      var r = this;
      return new Promise(function(n, i) {
        try {
          y.debug("items to be sent", t), r.send(t, n, i);
        } catch (o) {
          i(o);
        }
      });
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype.forceFlush = function() {
      return Promise.all(this._sendingPromises).then(function() {
      });
    }, e.prototype._shutdown = function() {
      return y.debug("shutdown started"), this.onShutdown(), this.forceFlush();
    }, e;
  }()
), Ed = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), kn = (
  /** @class */
  function(e) {
    Ed(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
), Td = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, vd = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url), Object.entries(n._parameters.headers).forEach(function(a) {
          var s = Td(a, 2), u = s[0], c = s[1];
          o.setRequestHeader(u, c);
        }), o.ontimeout = function(a) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (y.debug("XHR success"), i({
            status: "success"
          })) : o.status && pd(o.status) ? i({
            status: "retryable",
            retryInMillis: _d(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(new Blob([t], { type: n._parameters.headers["Content-Type"] }));
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function gd(e) {
  return new vd(e);
}
var md = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (y.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function yd(e) {
  return new md(e);
}
var Od = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(e, t || [])).next());
  });
}, Sd = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done) return o;
      switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
        case 0:
        case 1:
          o = c;
          break;
        case 4:
          return r.label++, { value: c[1], done: !1 };
        case 5:
          r.label++, i = c[1], c = [0];
          continue;
        case 7:
          c = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            r = 0;
            continue;
          }
          if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
            r.label = c[1];
            break;
          }
          if (c[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = c;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(c);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      c = t.call(e, r);
    } catch (l) {
      c = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, Rd = 5, Ad = 1e3, Nd = 5e3, Ld = 1.5, Un = 0.2;
function bd() {
  return Math.random() * (2 * Un) - Un;
}
var wd = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return Od(this, void 0, void 0, function() {
        var i, o, a, s, u, c, l;
        return Sd(this, function(f) {
          switch (f.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = f.sent(), a = Rd, s = Ad, f.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, u = Math.max(Math.min(s, Nd) + bd(), 0), s = s * Ld, c = (n = o.retryInMillis) !== null && n !== void 0 ? n : u, l = i - Date.now(), c > l ? [2, o] : [4, this.retry(t, l, c)]) : [3, 4];
            case 3:
              return o = f.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function Id(e) {
  return new wd(e.transport);
}
var Pd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Cd = (
  /** @class */
  function(e) {
    Pd(t, e);
    function t(r, n, i) {
      r === void 0 && (r = {});
      var o = e.call(this, r) || this;
      o._serializer = n;
      var a = !!r.headers || typeof navigator.sendBeacon != "function";
      return a ? o._transport = Id({
        transport: gd({
          headers: Object.assign({}, ld(r.headers), ud.parseKeyPairsIntoRecord(Lr().OTEL_EXPORTER_OTLP_HEADERS), { "Content-Type": i }),
          url: o.url
        })
      }) : o._transport = yd({
        url: o.url,
        blobType: i
      }), o;
    }
    return t.prototype.onInit = function() {
    }, t.prototype.onShutdown = function() {
    }, t.prototype.send = function(r, n, i) {
      var o = this;
      if (this._shutdownOnce.isCalled) {
        y.debug("Shutdown already started. Cannot send objects");
        return;
      }
      var a = this._serializer.serializeRequest(r);
      if (a == null) {
        i(new Error("Could not serialize message"));
        return;
      }
      var s = this._transport.send(a, this.timeoutMillis).then(function(c) {
        c.status === "success" ? n() : c.status === "failure" && c.error ? i(c.error) : c.status === "retryable" ? i(new kn("Export failed with retryable status")) : i(new kn("Export failed with unknown error"));
      }, i);
      this._sendingPromises.push(s);
      var u = function() {
        var c = o._sendingPromises.indexOf(s);
        o._sendingPromises.splice(c, 1);
      };
      s.then(u, u);
    }, t;
  }(hd)
);
function Bn(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function zr(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = Bn(e.charCodeAt(n)), o = Bn(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var xd = 9, Dd = Math.pow(10, xd);
function Md(e) {
  return e[0] * Dd + e[1];
}
function lo(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function kd(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function fo(e) {
  var t = lo(e);
  return kd(t);
}
function Ud(e) {
  var t = lo(e);
  return t.toString();
}
var Bd = typeof BigInt != "undefined" ? Ud : Md;
function Hn(e) {
  return e;
}
function po(e) {
  if (e !== void 0)
    return zr(e);
}
var Hd = {
  encodeHrTime: fo,
  encodeSpanContext: zr,
  encodeOptionalSpanContext: po
};
function Fd(e) {
  var t, r;
  if (e === void 0)
    return Hd;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? fo : Bd,
    encodeSpanContext: i ? Hn : zr,
    encodeOptionalSpanContext: i ? Hn : po
  };
}
var Gd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function jd(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Lt(e) {
  return Object.keys(e).map(function(t) {
    return _o(t, e[t]);
  });
}
function _o(e, t) {
  return {
    key: e,
    value: ho(t)
  };
}
function ho(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(ho) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = Gd(r, 2), i = n[0], o = n[1];
        return _o(i, o);
      })
    }
  } : {};
}
function Vd(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Lt(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return Xd(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return $d(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function $d(e, t) {
  var r;
  return {
    attributes: e.attributes ? Lt(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function Xd(e, t) {
  return {
    attributes: e.attributes ? Lt(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function qd(e) {
  return {
    attributes: Lt(e.attributes),
    droppedAttributesCount: 0
  };
}
var zd = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Yd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Wd(e, t) {
  var r = Fd(t);
  return {
    resourceSpans: Jd(e, r)
  };
}
function Kd(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = zd(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, s = n.get(a.resource);
      s || (s = /* @__PURE__ */ new Map(), n.set(a.resource, s));
      var u = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), c = s.get(u);
      c || (c = [], s.set(u, c)), c.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Jd(e, t) {
  for (var r = Kd(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = Yd(o.value, 2), s = a[0], u = a[1], c = [], l = u.values(), f = l.next(); !f.done; ) {
      var d = f.value;
      if (d.length > 0) {
        var _ = d.map(function(p) {
          return Vd(p, t);
        });
        c.push({
          scope: jd(d[0].instrumentationLibrary),
          spans: _,
          schemaUrl: d[0].instrumentationLibrary.schemaUrl
        });
      }
      f = l.next();
    }
    var E = {
      resource: qd(s),
      scopeSpans: c,
      schemaUrl: void 0
    };
    n.push(E), o = i.next();
  }
  return n;
}
var Qd = {
  serializeRequest: function(e) {
    var t = Wd(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, Zd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ep = "v1/traces", tp = "http://localhost:4318/" + ep, Fn = (
  /** @class */
  function(e) {
    Zd(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, r, Qd, "application/json") || this;
    }
    return t.prototype.getDefaultUrl = function(r) {
      return typeof r.url == "string" ? r.url : tp;
    }, t;
  }(Cd)
);
class rp extends Fn {
  constructor(r) {
    super(r);
    S(this, "xhrTraceExporter");
    this.xhrTraceExporter = new Fn(B(D({}, r != null ? r : {}), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    }));
  }
  send(r, n, i) {
    super.send(r, n, (o) => {
      o.message.toLocaleLowerCase().includes("beacon") ? this.xhrTraceExporter.send(r, n, (a) => {
        i(B(D({}, o), {
          message: `${o.message} --- [XHR retry message: ${a.message}; code: ${a.code}].`,
          code: o.code,
          data: `${o.data} --- [XHR retry data: ${a.data}].`
        }));
      }) : i(o);
    });
  }
}
const np = ["click", "input", "submit"];
function ip() {
  return !1;
}
class op extends Ot {
  constructor(r = {}) {
    var n;
    super("user-interaction", "1.0.0", r);
    S(this, "_spansData", /* @__PURE__ */ new WeakMap());
    // for addEventListener/removeEventListener state
    S(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
    // for event bubbling
    S(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
    S(this, "_eventNames");
    S(this, "_shouldPreventSpanCreation");
    this._eventNames = new Set((n = r == null ? void 0 : r.eventNames) != null ? n : np), this._shouldPreventSpanCreation = typeof (r == null ? void 0 : r.shouldPreventSpanCreation) == "function" ? r.shouldPreventSpanCreation : ip;
  }
  init() {
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(r) {
    return this._eventNames.has(r);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(r, n) {
    var s;
    const i = r == null ? void 0 : r.target, o = r == null ? void 0 : r.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = Hi(i, !0);
    try {
      const u = this.tracer.startSpan(o, {
        attributes: {
          "event.type": o,
          "event.tag": i.tagName,
          "event.xpath": a,
          "event.id": i.id,
          "event.text": (s = i.textContent) != null ? s : "",
          "event.url": window.location.href,
          "viewport.width": window.innerWidth,
          "viewport.height": window.innerHeight
        }
      }, n ? L.setSpan(N.active(), n) : void 0);
      return r instanceof MouseEvent && (u.setAttribute("event.x", r.clientX), u.setAttribute("event.y", r.clientY), u.setAttribute("event.relativeX", r.clientX / window.innerWidth), u.setAttribute("event.relativeY", r.clientY / window.innerHeight), o === "scroll" && (u.setAttribute("event.scrollX", window.scrollX), u.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, u) === !0 ? void 0 : (this._spansData.set(u, {
        taskCount: 0
      }), u);
    } catch (u) {
      this._diag.error("failed to start create new user interaction span", u);
    }
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(r, n, i, o) {
    let a = this._wrappedListeners.get(i);
    a || (a = /* @__PURE__ */ new Map(), this._wrappedListeners.set(i, a));
    let s = a.get(n);
    return s || (s = /* @__PURE__ */ new Map(), a.set(n, s)), s.has(r) ? !1 : (s.set(r, o), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(r, n, i) {
    const o = this._wrappedListeners.get(i);
    if (!o)
      return;
    const a = o.get(n);
    if (!a)
      return;
    const s = a.get(r);
    return s && (a.delete(r), a.size === 0 && (o.delete(n), o.size === 0 && this._wrappedListeners.delete(i))), s;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(r, n, i) {
    return typeof r == "function" ? r.apply(n, i) : r.handleEvent(i[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   */
  _patchAddEventListener() {
    const r = this;
    let n = 0;
    return (i) => function(a, s, u) {
      if (!s)
        return i.call(this, a, s, u);
      const c = u && typeof u == "object" && u.once, l = function(...f) {
        let d;
        const _ = f[0];
        if ((_ == null ? void 0 : _.type) === "mousemove" && Date.now() - n < 1e3 / 60)
          return i.call(this, a, s, u);
        n = Date.now(), _ && (d = r._eventsSpanMap.get(_)), c && r.removePatchedListener(this, a, s);
        const E = r._createSpan(_, d);
        return E ? (_ && r._eventsSpanMap.set(_, E), N.with(L.setSpan(N.active(), E), () => {
          const p = r._invokeListener(s, this, f);
          return E.end(), p;
        })) : r._invokeListener(s, this, f);
      };
      if (r.addPatchedListener(this, a, s, l))
        return i.call(this, a, l, u);
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   */
  _patchRemoveEventListener() {
    const r = this;
    return (n) => function(o, a, s) {
      const u = r.removePatchedListener(this, o, a);
      return u ? n.call(this, o, u, s) : n.call(this, o, a, s);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * implements enable function
   */
  enable() {
    this._getPatchableEventTargets().forEach((n) => {
      oe(n.addEventListener) && (this._unwrap(n, "addEventListener"), this._diag.debug("removing previous patch from method addEventListener")), oe(n.removeEventListener) && (this._unwrap(n, "removeEventListener"), this._diag.debug("removing previous patch from method removeEventListener")), this._wrap(n, "addEventListener", this._patchAddEventListener()), this._wrap(n, "removeEventListener", this._patchRemoveEventListener());
    });
  }
  /**
   * implements unpatch function
   */
  disable() {
    this._getPatchableEventTargets().forEach((n) => {
      oe(n.addEventListener) && this._unwrap(n, "addEventListener"), oe(n.removeEventListener) && this._unwrap(n, "removeEventListener");
    });
  }
}
let Z;
const vt = "highlight.record", Cp = (e) => {
  var u, c, l, f, d;
  if (Z !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  const t = e.backendUrl || void 0 || "https://pub.highlight.run", r = [
    ...(c = (u = e.networkRecordingOptions) == null ? void 0 : u.urlBlocklist) != null ? c : [],
    ...to
  ], n = (l = e.environment) != null ? l : "production";
  Z = new Wc({
    resource: new Dl({
      [Ss]: (f = e.serviceName) != null ? f : "highlight-browser",
      [ys]: n,
      "highlight.project_id": e.projectId,
      "highlight.session_id": e.sessionSecureId
    })
  });
  const i = new rp({
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip"
  }), o = new ap(i, {
    maxExportBatchSize: 15
  });
  Z.addSpanProcessor(o);
  let a = [
    new sl({
      applyCustomAttributesOnSpan: {
        documentLoad: Vn,
        documentFetch: Vn,
        resourceFetch: dp
      }
    }),
    new op()
  ];
  (d = e.networkRecordingOptions) != null && d.enabled && (a.push(new vl({
    propagateTraceHeaderCorsUrls: $n(e.tracingOrigins),
    applyCustomAttributesOnSpan: (_, E, p) => F(void 0, null, function* () {
      var I, H, U;
      const v = _;
      if (v.attributes[vt] === !1)
        return;
      const T = v.attributes["http.url"], O = (I = E.method) != null ? I : "GET";
      if (_.updateName(Gn(T, O, E.body)), !(p instanceof Response)) {
        _.setAttributes({
          "http.response.error": p.message,
          "http.response.status": p.status
        });
        return;
      }
      jn(_, E.body, E.headers, e.networkRecordingOptions);
      const b = yield io(p, (H = e.networkRecordingOptions) == null ? void 0 : H.bodyKeysToRecord, (U = e.networkRecordingOptions) == null ? void 0 : U.networkBodyKeysToRedact);
      _.setAttribute("http.response.body", b);
    })
  })), a.push(new wl({
    propagateTraceHeaderCorsUrls: $n(e.tracingOrigins),
    applyCustomAttributesOnSpan: (_, E) => {
      var b, I;
      const p = E;
      if (_.attributes[vt] === !1)
        return;
      const T = Gn(p._url, p._method, E.responseText);
      _.updateName(T), jn(_, p._body, p._requestHeaders, e.networkRecordingOptions);
      const O = K(p._body, (b = e.networkRecordingOptions) == null ? void 0 : b.networkBodyKeysToRedact, (I = e.networkRecordingOptions) == null ? void 0 : I.bodyKeysToRecord, p._requestHeaders);
      _.setAttribute("http.request.body", O);
    }
  }))), Zs({ instrumentations: a });
  const s = new ki();
  s.enable(), Z.register({
    contextManager: s,
    propagator: new bs({
      propagators: [
        new Za(),
        new sp({
          backendUrl: t,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: r
        })
      ]
    })
  });
};
class ap extends Mi {
  onEnd(t) {
    t.attributes[vt] !== !1 && super.onEnd(t);
  }
}
class sp extends Xs {
  constructor(r) {
    super();
    S(this, "highlightEndpoints");
    S(this, "tracingOrigins");
    S(this, "urlBlocklist");
    this.highlightEndpoints = [r.backendUrl, r.otlpEndpoint], this.tracingOrigins = r.tracingOrigins, this.urlBlocklist = r.urlBlocklist;
  }
  inject(r, n, i) {
    const o = L.getSpan(r);
    if (!o)
      return;
    const a = o.attributes["http.url"];
    if (typeof a == "string" && !fp(a, this.highlightEndpoints, this.tracingOrigins, this.urlBlocklist)) {
      o.setAttribute(vt, !1);
      return;
    }
    super.inject(r, n, i);
  }
}
const up = "highlight-browser", xp = () => Z.getTracer(up), cp = () => L.getActiveSpan(), lp = () => F(void 0, null, function* () {
  Z !== void 0 && (yield Z.forceFlush(), Z.shutdown());
}), Gn = (e, t, r) => {
  var s, u, c;
  let n;
  const i = new URL(e), o = i.pathname;
  let a = `${t.toUpperCase()} - ${o}`;
  try {
    if (n = typeof r == "string" ? JSON.parse(r) : r, n && n.query) {
      const l = df(n.query), f = ((s = l.definitions[0]) == null ? void 0 : s.kind) === "OperationDefinition" ? (c = (u = l.definitions[0]) == null ? void 0 : u.name) == null ? void 0 : c.value : void 0;
      f && (a = `${f} (GraphQL: ${i.host + i.pathname})`);
    }
  } catch (l) {
  }
  return a;
}, jn = (e, t, r, n) => {
  var l;
  const i = typeof t == "string" ? t : String(t), a = e.attributes["http.url"], s = new URL(a);
  let u;
  try {
    u = t ? JSON.parse(i) : void 0, u.operationName && e.setAttribute("graphql.operation.name", u.operationName);
  } catch (f) {
  }
  const c = eo((l = n == null ? void 0 : n.networkHeadersToRedact) != null ? l : [], r, n == null ? void 0 : n.headerKeysToRecord);
  e.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(c),
    "http.request.body": i,
    [Rs]: a,
    [As]: s.pathname,
    [Ns]: s.search
  }), s.searchParams.size > 0 && e.setAttributes({
    // Custom attribute that displays query string params as an object.
    "url.query_params": JSON.stringify(Object.fromEntries(s.searchParams))
  });
}, fp = (e, t, r, n) => n != null && n.some((o) => e.toLowerCase().includes(o)) ? !1 : Nt(e, t, r), Vn = (e) => {
  const r = e.events, n = {
    unload: G("unloadEventStart", "unloadEventEnd", r),
    dom_interactive: G("domInteractive", "fetchStart", r),
    dom_content_loaded: G("domContentLoadedEventEnd", "domContentLoadedEventStart", r),
    dom_complete: G("fetchStart", "domComplete", r),
    load_event: G("loadEventStart", "loadEventEnd", r),
    first_paint: G("fetchStart", "firstPaint", r),
    first_contentful_paint: G("fetchStart", "firstContentfulPaint", r),
    domain_lookup: G("domainLookupStart", "domainLookupEnd", r),
    connect: G("connectStart", "connectEnd", r),
    request: G("requestStart", "requestEnd", r),
    response: G("responseStart", "responseEnd", r)
  };
  Object.entries(n).forEach(([i, o]) => {
    o > 0 && (e.setAttribute(`timings.${i}.ns`, o), e.setAttribute(`timings.${i}.readable`, Eo(o)));
  });
};
function G(e, t, r) {
  const n = r.find((s) => s.name === e), i = r.find((s) => s.name === t);
  if (!n || !i)
    return 0;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const dp = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e6,
    connect: (t.connectEnd - t.connectStart) * 1e6,
    request: (t.responseEnd - t.requestStart) * 1e6,
    response: (t.responseEnd - t.responseStart) * 1e6
  };
  Object.entries(r).forEach(([n, i]) => {
    i > 0 && (e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, Eo(i)));
  });
}, Eo = (e) => {
  if (e >= 36e11) {
    const a = e / 36e11;
    return `${Number(a.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const a = e / 6e10;
    return `${Number(a.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const a = e / 1e9;
    return `${Number(a.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const a = e / 1e6;
    return `${Number(a.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const a = e / 1e3;
    return `${Number(a.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, $n = (e) => e === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(e) ? e.map((t) => typeof t == "string" ? new RegExp(t) : t) : /^$/, pp = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var Xn;
(function(e) {
  e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea";
})(Xn || (Xn = {}));
var qn;
(function(e) {
  e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend";
})(qn || (qn = {}));
const _p = (e, t, r) => {
  const n = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = e;
  const i = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (o) => {
    const f = o, { message: a, size: s } = f, u = It(f, ["message", "size"]), l = r.some((d) => o.name.toLowerCase().includes(d)) ? u : o;
    t(l);
  }, () => {
    window._highlightWebSocketRequestCallback = n, window._highlightWebSocketEventCallback = i;
  };
}, hp = ({ xhrCallback: e, fetchCallback: t, webSocketRequestCallback: r, webSocketEventCallback: n, disableWebSocketRecording: i, bodyKeysToRedact: o, highlightEndpoints: a, tracingOrigins: s, urlBlocklist: u, bodyKeysToRecord: c }) => {
  const l = Pf(e, a, s, u, o, c), f = xf(t, a, s, u, o, c), d = i ? () => {
  } : _p(r, n, u);
  return () => {
    l(), f(), d();
  };
};
class Yr {
  constructor(t) {
    S(this, "disableConsoleRecording");
    S(this, "reportConsoleErrors");
    S(this, "enablePromisePatch");
    S(this, "consoleMethodsToRecord");
    S(this, "listeners");
    S(this, "errors");
    S(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    S(this, "options");
    S(this, "hasNetworkRecording", !0);
    S(this, "disableNetworkRecording");
    S(this, "enableRecordingNetworkContents");
    S(this, "xhrNetworkContents");
    S(this, "fetchNetworkContents");
    S(this, "disableRecordingWebSocketContents");
    S(this, "webSocketNetworkContents");
    S(this, "webSocketEventContents");
    S(this, "tracingOrigins");
    S(this, "networkHeadersToRedact");
    S(this, "networkBodyKeysToRedact");
    S(this, "networkBodyKeysToRecord");
    S(this, "networkHeaderKeysToRecord");
    S(this, "lastNetworkRequestTimestamp");
    S(this, "urlBlocklist");
    S(this, "highlightEndpoints");
    S(this, "requestResponseSanitizer");
    var r, n;
    this.options = t, this.disableConsoleRecording = !!t.disableConsoleRecording, this.reportConsoleErrors = (r = t.reportConsoleErrors) != null ? r : !1, this.enablePromisePatch = (n = t.enablePromisePatch) != null ? n : !1, this.consoleMethodsToRecord = t.consoleMethodsToRecord || [
      ...pp
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening())
      return;
    const t = this;
    this.disableConsoleRecording || this.listeners.push(Io((r) => {
      var n, i, o;
      if (this.reportConsoleErrors && (r.type === "Error" || r.type === "error") && r.value && r.trace) {
        const a = st(r.value);
        if (Qr.includes(a) || Zr.some((s) => a.includes(s)))
          return;
        t.errors.push({
          event: a,
          type: "console.error",
          url: window.location.href,
          source: (n = r.trace[0]) != null && n.fileName ? r.trace[0].fileName : "",
          lineNumber: (i = r.trace[0]) != null && i.lineNumber ? r.trace[0].lineNumber : 0,
          columnNumber: (o = r.trace[0]) != null && o.columnNumber ? r.trace[0].columnNumber : 0,
          stackTrace: r.trace,
          timestamp: (/* @__PURE__ */ new Date()).toISOString()
        });
      }
      t.messages.push(r);
    }, {
      level: this.consoleMethodsToRecord,
      logger: "console",
      stringifyOptions: {
        depthOfLimit: 10,
        numOfKeysLimit: 100,
        stringLengthLimit: 1e3
      }
    })), this.listeners.push(Co((r) => {
      Qr.includes(r.event) || Zr.some((n) => r.event.includes(n)) || t.errors.push(r);
    }, { enablePromisePatch: this.enablePromisePatch })), this.listeners.push(lp), Yr.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((t) => t()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(t, r) {
    var o, a, s, u, c, l, f, d, _, E, p, v;
    const n = (r == null ? void 0 : r.backendUrl) || void 0 || "https://pub.highlight.run", i = r.otlpEndpoint || "https://otel.highlight.io";
    t.highlightEndpoints = [n, i], t.xhrNetworkContents = [], t.fetchNetworkContents = [], t.webSocketNetworkContents = [], t.webSocketEventContents = [], t.networkHeadersToRedact = [], t.urlBlocklist = [], t.tracingOrigins = r.tracingOrigins || [], (r == null ? void 0 : r.disableNetworkRecording) !== void 0 ? (t.disableNetworkRecording = r == null ? void 0 : r.disableNetworkRecording, t.enableRecordingNetworkContents = !1, t.disableRecordingWebSocketContents = !0, t.networkHeadersToRedact = [], t.networkBodyKeysToRedact = [], t.urlBlocklist = [], t.networkBodyKeysToRecord = []) : typeof (r == null ? void 0 : r.networkRecording) == "boolean" ? (t.disableNetworkRecording = !r.networkRecording, t.enableRecordingNetworkContents = !1, t.disableRecordingWebSocketContents = !0, t.networkHeadersToRedact = [], t.networkBodyKeysToRedact = [], t.urlBlocklist = []) : (((o = r.networkRecording) == null ? void 0 : o.enabled) !== void 0 ? t.disableNetworkRecording = !r.networkRecording.enabled : t.disableNetworkRecording = !1, t.enableRecordingNetworkContents = ((a = r.networkRecording) == null ? void 0 : a.recordHeadersAndBody) || !1, t.disableRecordingWebSocketContents = ((s = r.networkRecording) == null ? void 0 : s.disableWebSocketEventRecordings) || !1, t.networkHeadersToRedact = ((c = (u = r.networkRecording) == null ? void 0 : u.networkHeadersToRedact) == null ? void 0 : c.map((T) => T.toLowerCase())) || [], t.networkBodyKeysToRedact = ((f = (l = r.networkRecording) == null ? void 0 : l.networkBodyKeysToRedact) == null ? void 0 : f.map((T) => T.toLowerCase())) || [], t.urlBlocklist = ((_ = (d = r.networkRecording) == null ? void 0 : d.urlBlocklist) == null ? void 0 : _.map((T) => T.toLowerCase())) || [], t.urlBlocklist = [
      ...t.urlBlocklist,
      ...to
    ], t.requestResponseSanitizer = (E = r.networkRecording) == null ? void 0 : E.requestResponseSanitizer, t.networkHeaderKeysToRecord = (p = r.networkRecording) == null ? void 0 : p.headerKeysToRecord, t.networkHeaderKeysToRecord && (t.networkHeadersToRedact = [], t.networkHeaderKeysToRecord = t.networkHeaderKeysToRecord.map((T) => T.toLocaleLowerCase())), t.networkBodyKeysToRecord = (v = r.networkRecording) == null ? void 0 : v.bodyKeysToRecord, t.networkBodyKeysToRecord && (t.networkBodyKeysToRedact = [], t.networkBodyKeysToRecord = t.networkBodyKeysToRecord.map((T) => T.toLocaleLowerCase()))), !t.disableNetworkRecording && t.enableRecordingNetworkContents && t.listeners.push(hp({
      xhrCallback: (T) => {
        t.xhrNetworkContents.push(T);
      },
      fetchCallback: (T) => {
        t.fetchNetworkContents.push(T);
      },
      webSocketRequestCallback: (T) => {
        t.webSocketNetworkContents && t.webSocketNetworkContents.push(T);
      },
      webSocketEventCallback: (T) => {
        t.webSocketEventContents.push(T);
      },
      disableWebSocketRecording: t.disableRecordingWebSocketContents,
      bodyKeysToRedact: t.networkBodyKeysToRedact,
      highlightEndpoints: t.highlightEndpoints,
      tracingOrigins: t.tracingOrigins,
      urlBlocklist: t.urlBlocklist,
      bodyKeysToRecord: t.networkBodyKeysToRecord
    }));
  }
  static getRecordedNetworkResources(t, r) {
    var o, a;
    let n = [], i = [];
    if (!t.disableNetworkRecording) {
      const s = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      n = performance.getEntriesByType("resource");
      const u = (r - s) * 2;
      if (n = n.filter((c) => c.responseEnd < t.lastNetworkRequestTimestamp ? !1 : Nt(c.name, t.highlightEndpoints, t.tracingOrigins)).map((c) => B(D({}, c.toJSON()), {
        offsetStartTime: c.startTime - u,
        offsetResponseEnd: c.responseEnd - u,
        offsetFetchStart: c.fetchStart - u
      })), t.lastNetworkRequestTimestamp = ((a = n.at(-1)) == null ? void 0 : a.responseEnd) || t.lastNetworkRequestTimestamp, t.enableRecordingNetworkContents) {
        const c = {
          headersToRedact: t.networkHeadersToRedact,
          headersToRecord: t.networkHeaderKeysToRecord,
          requestResponseSanitizer: t.requestResponseSanitizer
        };
        n = xn(n, t.xhrNetworkContents, "xmlhttprequest", c), n = xn(n, t.fetchNetworkContents, "fetch", c);
      }
    }
    return t.disableRecordingWebSocketContents || (i = t.webSocketNetworkContents || []), [...n, ...i];
  }
  static getRecordedWebSocketEvents(t) {
    let r = [];
    return !t.disableNetworkRecording && !t.disableRecordingWebSocketContents && (r = t.webSocketEventContents), r;
  }
  static clearRecordedNetworkResources(t) {
    t.disableNetworkRecording || (t.xhrNetworkContents = [], t.fetchNetworkContents = [], t.webSocketNetworkContents = [], t.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const Ep = () => {
  var o;
  const t = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var r = "";
  const n = typeof window != "undefined" && ((o = window.crypto) == null ? void 0 : o.getRandomValues), i = new Uint32Array(28);
  n && window.crypto.getRandomValues(i);
  for (let a = 0; a < 28; a++)
    n ? r += t.charAt(i[a] % t.length) : r += t.charAt(Math.floor(Math.random() * t.length));
  return r;
}, Tp = "9.7.2", vp = () => {
  var e, t;
  typeof chrome != "undefined" && ((e = chrome == null ? void 0 : chrome.runtime) != null && e.onMessage) && ((t = chrome == null ? void 0 : chrome.runtime) == null || t.onMessage.addListener((r, n, i) => {
    const o = r.action;
    switch (console.log(`[highlight] received '${o}' event from extension.`), o) {
      case "init": {
        w.init(1, {
          debug: !0
        }), w.getSessionURL().then((a) => {
          i({ url: a });
        });
        break;
      }
      case "stop": {
        w.stop(), i({ success: !0 });
        break;
      }
    }
    return !0;
  }));
};
function Dp(e) {
  var t;
  e.on && ((t = e.webContents) != null && t.send) && (e.on("focus", () => {
    e.webContents.send("highlight.run", { visible: !0 });
  }), e.on("blur", () => {
    e.webContents.send("highlight.run", { visible: !1 });
  }), e.on("close", () => {
    e.webContents.send("highlight.run", { visible: !1 });
  }));
}
const Mp = ({ next: e, payload: t }) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (t.obj.type === "track") {
      const r = t.obj.event, n = t.obj.properties;
      window.H.track(r, n);
    } else if (t.obj.type === "identify") {
      const r = t.obj.userId;
      if (r != null && r.length) {
        const n = t.obj.traits;
        window.H.identify(r, n);
      }
    }
  }
  e(t);
}, br = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (e, t) => window._originalFetch(e, t), window._highlightFetchPatch = (e, t) => window._fetchProxy.call(window || global, e, t), window.fetch = window._highlightFetchPatch;
  }
}, zn = () => null, wr = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = zn, window._highlightWebSocketEventCallback = zn;
    const e = new Proxy(window.WebSocket, {
      construct(t, r) {
        const [, n] = qr(), i = new t(...r), o = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "open",
            name: i.url,
            startTimeAbs: performance.timeOrigin + l.timeStamp
          });
        }, a = (l) => {
          window._highlightWebSocketRequestCallback({
            socketId: n,
            initiatorType: "websocket",
            type: "close",
            name: i.url,
            responseEndAbs: performance.timeOrigin + l.timeStamp
          }), i.removeEventListener("open", o), i.removeEventListener("error", u), i.removeEventListener("message", s), i.removeEventListener("close", a);
        }, s = (l) => {
          const { data: f } = l, d = typeof f == "string" ? l.data : void 0;
          let _;
          typeof f == "string" ? _ = f.length : f instanceof Blob ? _ = f.size : _ = f.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: n,
            type: "received",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: _,
            message: d
          });
        }, u = (l) => {
          window._highlightWebSocketEventCallback({
            socketId: n,
            type: "error",
            name: i.url,
            timeStamp: performance.timeOrigin + l.timeStamp,
            size: 0
          });
        };
        i.addEventListener("open", o), i.addEventListener("error", u), i.addEventListener("message", s), i.addEventListener("close", a);
        const c = new Proxy(i.send, {
          apply: function(l, f, d) {
            const _ = d[0], E = typeof _ == "string" ? _ : void 0;
            let p;
            typeof _ == "string" ? p = _.length : _ instanceof Blob ? p = _.size : p = _.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: n,
              type: "sent",
              name: i.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: p,
              message: E
            }), l.apply(f, d);
          }
        });
        return i.send = c, i;
      }
    });
    window.WebSocket = e;
  }
}, Yn = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, r) => e,
    setAttributes: (t) => e,
    addEvent: (t, r, n) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
};
var Ir;
(function(e) {
  e.Device = "Device", e.WebVital = "WebVital", e.Frontend = "Frontend", e.Backend = "Backend";
})(Ir || (Ir = {}));
const X = (e, t) => {
  console.warn(`highlight.run warning: (${e}): `, t);
}, gp = 200;
let Pe = [], ot, R, Ce, Pr = !1, we;
const w = {
  options: void 0,
  init: (e, t) => {
    var r, n, i, o, a, s, u, c;
    try {
      if (w.options = t, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!e) {
        console.info("Highlight is not initializing because projectID was passed undefined.");
        return;
      }
      t != null && t.skipCookieSessionDataLoad ? vf(!1) : Nf();
      let l = rr(), f = Ep();
      if (l != null && l.sessionSecureID && (f = l.sessionSecureID), Pr)
        return { sessionSecureID: f };
      Pr = !0, br(), wr(), import("./index-DjMApXNi.js").then((v) => F(void 0, [v], function* ({ Highlight: _, setupBrowserTracing: E, getTracer: p }) {
        var T, O, b;
        E({
          otlpEndpoint: (T = t == null ? void 0 : t.otlpEndpoint) != null ? T : "https://otel.highlight.io",
          projectId: e,
          sessionSecureId: f,
          environment: (O = t == null ? void 0 : t.environment) != null ? O : "production",
          networkRecordingOptions: typeof (t == null ? void 0 : t.networkRecording) == "object" ? t.networkRecording : void 0,
          tracingOrigins: t == null ? void 0 : t.tracingOrigins,
          serviceName: (b = t == null ? void 0 : t.serviceName) != null ? b : "highlight-browser"
        }), we = p, R = new _(d, Ce), br(), wr(), t != null && t.manualStart || (yield R.initialize());
      }));
      const d = B(D({}, t), {
        organizationID: e,
        firstloadVersion: Tp,
        environment: (t == null ? void 0 : t.environment) || "production",
        appVersion: t == null ? void 0 : t.version,
        sessionSecureID: f
      });
      return Ce = new Yr(d), t != null && t.manualStart || Ce.startListening(), !((n = (r = t == null ? void 0 : t.integrations) == null ? void 0 : r.mixpanel) != null && n.disabled) && ((o = (i = t == null ? void 0 : t.integrations) == null ? void 0 : i.mixpanel) != null && o.projectToken) && Oo(t.integrations.mixpanel), !((s = (a = t == null ? void 0 : t.integrations) == null ? void 0 : a.amplitude) != null && s.disabled) && ((c = (u = t == null ? void 0 : t.integrations) == null ? void 0 : u.amplitude) != null && c.apiKey) && yo(t.integrations.amplitude), { sessionSecureID: f };
    } catch (l) {
      X("init", l);
    }
  },
  snapshot: (e) => F(void 0, null, function* () {
    try {
      if (R && R.ready)
        return yield R.snapshot(e);
    } catch (t) {
      X("snapshot", t);
    }
  }),
  addSessionFeedback: ({ verbatim: e, userName: t, userEmail: r, timestampOverride: n }) => {
    try {
      w.onHighlightReady(() => R.addSessionFeedback({
        verbatim: e,
        timestamp: n || (/* @__PURE__ */ new Date()).toISOString(),
        user_email: r,
        user_name: t
      }));
    } catch (i) {
      X("error", i);
    }
  },
  consumeError: (e, t, r) => {
    try {
      w.onHighlightReady(() => R.consumeCustomError(e, t, JSON.stringify(r)));
    } catch (n) {
      X("error", n);
    }
  },
  consume: (e, t) => {
    try {
      w.onHighlightReady(() => R.consumeError(e, t));
    } catch (r) {
      X("error", r);
    }
  },
  error: (e, t) => {
    try {
      w.onHighlightReady(() => R.pushCustomError(e, JSON.stringify(t)));
    } catch (r) {
      X("error", r);
    }
  },
  track: (e, t = {}) => {
    var r, n, i, o, a, s, u, c, l, f, d;
    try {
      w.onHighlightReady(() => R.addProperties(B(D({}, t), { event: e })));
      const _ = R == null ? void 0 : R.getCurrentSessionURL();
      (i = (n = (r = w.options) == null ? void 0 : r.integrations) == null ? void 0 : n.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.track && window.mixpanel.track(e, B(D({}, t), {
        highlightSessionURL: _
      })), (u = (s = (a = w.options) == null ? void 0 : a.integrations) == null ? void 0 : s.amplitude) != null && u.disabled || (c = window.amplitude) != null && c.getInstance && window.amplitude.getInstance().logEvent(e, B(D({}, t), {
        highlightSessionURL: _
      })), (d = (f = (l = w.options) == null ? void 0 : l.integrations) == null ? void 0 : f.intercom) != null && d.disabled || window.Intercom && window.Intercom("trackEvent", e, t);
    } catch (_) {
      X("track", _);
    }
  },
  start: (e) => {
    (R == null ? void 0 : R.state) === "Recording" && !(e != null && e.forceNew) ? e != null && e.silent || console.warn("Highlight is already recording. Please `H.stop()` the current session before starting a new one.") : (Ce.startListening(), w.onHighlightReady(() => F(void 0, null, function* () {
      yield R.initialize(e);
    }), { waitForReady: !1 }));
  },
  stop: (e) => {
    (R == null ? void 0 : R.state) !== "Recording" ? e != null && e.silent || console.warn("Highlight is already stopped. Please call `H.start()`.") : w.onHighlightReady(() => R.stopRecording(!0));
  },
  identify: (e, t = {}) => {
    var r, n, i, o, a, s, u, c;
    try {
      w.onHighlightReady(() => R.identify(e, t));
    } catch (l) {
      X("identify", l);
    }
    if ((i = (n = (r = w.options) == null ? void 0 : r.integrations) == null ? void 0 : n.mixpanel) != null && i.disabled || (o = window.mixpanel) != null && o.identify && (window.mixpanel.identify(typeof (t == null ? void 0 : t.email) == "string" ? t == null ? void 0 : t.email : e), t && (window.mixpanel.track("identify", t), window.mixpanel.people.set(t))), !((u = (s = (a = w.options) == null ? void 0 : a.integrations) == null ? void 0 : s.amplitude) != null && u.disabled) && (c = window.amplitude) != null && c.getInstance && (window.amplitude.getInstance().setUserId(e), Object.keys(t).length > 0)) {
      const l = Object.keys(t).reduce((f, d) => (f.set(d, t[d]), f), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(l);
    }
  },
  metrics: (e) => {
    try {
      w.onHighlightReady(() => R.recordMetric(e.map((t) => B(D({}, t), {
        category: Ir.Frontend
      }))));
    } catch (t) {
      X("metrics", t);
    }
  },
  startSpan: (e, t, r, n) => {
    const i = typeof we == "function" ? we() : void 0;
    if (!i) {
      const a = Yn();
      return n === void 0 && r === void 0 ? t(a) : n === void 0 ? r(a) : n(a);
    }
    const o = (a, s) => {
      const u = s(a);
      return u instanceof Promise ? u.finally(() => a.end()) : (a.end(), u);
    };
    return n === void 0 && r === void 0 ? i.startActiveSpan(e, (a) => o(a, t)) : n === void 0 ? i.startActiveSpan(e, t, (a) => o(a, r)) : i.startActiveSpan(e, t, r, (a) => o(a, n));
  },
  startManualSpan: (e, t, r, n) => {
    const i = typeof we == "function" ? we() : void 0;
    if (!i) {
      const o = Yn();
      return n === void 0 && r === void 0 ? t(o) : n === void 0 ? r(o) : n(o);
    }
    return n === void 0 && r === void 0 ? i.startActiveSpan(e, t) : n === void 0 ? i.startActiveSpan(e, t, r) : i.startActiveSpan(e, t, r, n);
  },
  getSessionURL: () => new Promise((e, t) => {
    w.onHighlightReady(() => {
      const r = R.sessionData.sessionSecureID, n = rr(r);
      n ? e(`https://${Ro}/${n.projectID}/sessions/${r}`) : t(new Error(`Unable to get session URL: ${r}`));
    });
  }),
  getSessionDetails: () => new Promise((e, t) => {
    w.onHighlightReady(() => F(void 0, null, function* () {
      try {
        const r = yield w.getSessionURL();
        if (!r)
          throw new Error("Could not get session URL");
        const n = R.sessionData.sessionSecureID, i = rr(n), o = i == null ? void 0 : i.sessionStartTime;
        if (!o)
          throw new Error("Could not get session start timestamp");
        const a = (/* @__PURE__ */ new Date()).getTime(), s = new URL(r), u = new URL(r);
        u.searchParams.set("ts", ((a - o) / 1e3).toString()), e({
          url: s.toString(),
          urlWithTimestamp: u.toString(),
          sessionSecureID: n
        });
      } catch (r) {
        t(r);
      }
    }));
  }),
  getRecordingState: () => {
    var e;
    return (e = R == null ? void 0 : R.state) != null ? e : "NotRecording";
  },
  onHighlightReady: (e, t) => {
    if (R && R.ready) {
      e();
      return;
    }
    if (Pe.push({ options: t, func: e }), ot !== void 0)
      return;
    const r = () => {
      Pe = Pe.filter((i) => {
        var o;
        return !R || ((o = i.options) == null ? void 0 : o.waitForReady) !== !1 && !R.ready ? !0 : (i.func(), !1);
      }), ot = void 0, Pe.length > 0 && (ot = setTimeout(r, gp));
    };
    r();
  }
};
typeof window != "undefined" && (window.H = w);
vp();
br();
wr();
const kp = {
  reset: () => {
    Pr = !1, R = void 0, Pe = [], ot = void 0, Ce = void 0;
  },
  setHighlightObj: (e) => {
    R = e;
  }
};
export {
  w as A,
  Mp as B,
  Ir as C,
  at as E,
  Yr as F,
  Ep as G,
  Ro as H,
  g as K,
  Xn as M,
  Gl as Q,
  Oe as S,
  Ap as V,
  kp as _,
  Yi as a,
  df as b,
  Wn as c,
  Zt as d,
  Ji as e,
  rr as f,
  Kn as g,
  Np as h,
  bp as i,
  Sf as j,
  Af as k,
  yp as l,
  Pp as m,
  qn as n,
  Sp as o,
  wp as p,
  Op as q,
  gf as r,
  Qi as s,
  st as t,
  Rp as u,
  Ip as v,
  vf as w,
  xp as x,
  Cp as y,
  Dp as z
};
//# sourceMappingURL=index-Cmw1NRXn.js.map
